{
  "navigation": {
    "_comment": "Titles for nav links and header titles of pages",
    "main": {
      "CourseScreen": "Courses and Modules",
      "ModuleScreen": "Module Overview",
      "TaskScreen": "Current Task",
      "GradeScreen": "Grades"
    },
    "my-modules": "My Modules",
    "about": "About",
    "learning-title": "Learning",
    "module-title": "Module",
    "learning-path": "Learning Path",
    "resources": "Resources",
    "taskscreen": {
      "instructions": "Instructions",
      "composer": "Composer",
      "resources": "Resources",
      "aiTutor": "AI Tutor"
    },
    "sidebar": {
      "menu": {
        "logout": "Logout",
        "change-password": "Change Password",
        "profile": "Profile",
        "myConnections": "My connections"
      }
    }
  },
  "calendar": {
    "more": "+{moreCount} more"
  },
  "errors": {
    "connection_lost": "Connection Lost",
    "save_failed": "Save Failed",
    "validation_error": "The data you entered is not valid.",
    "not_found": "The requested resource could not be found.",
    "permission_denied": "You don't have permission to perform this action.",
    "unauthorized": "Your session has expired or you are not authorized to perform this action.",
    "forbidden": "You do not have permission to perform this action.",
    "internal_error": "An unexpected error occurred on our servers.",
    "server_error": "A server error occurred. Please try again later.",
    "unknown_error": "Something went wrong. Please try again.",
    "could_not_complete_action": "Could not complete action",
    "task_objectives_required": "Please generate task objectives first before generating a rubric.",
    "module_version_already_exists": "A draft with this version already exists. Please reload and continue editing that draft.",
    "module_version_replacement_invalid": "This replacement request is not allowed because tasks differ between source and draft versions. Use 'Publish as New Version' or align tasks first.",
    "invalid_image_format": "Unsupported image format. Please upload a JPG or PNG image.",
    "invalid_task_objectives": "Invalid task objectives: Dimension '{{dimension}}' is not configured in tenant settings",
    "submission_attachment_invalid_filetype": "Invalid file type. Allowed: {{types}}.",
    "submission_attachment_image_too_large": "Image resolution is too large.",
    "auth_duplicate_email": "This email is associated with multiple accounts. Please contact support.",
    "auth_invalid_token": "The reset token is invalid or has expired.",
    "auth_invalid_password": "The password does not meet the security requirements.",
    "auth_password_policy_violated": "The password does not meet the security requirements.",
    "auth_old_password_incorrect": "The current password you entered is incorrect.",
    "auth_invalid_credentials": "The current password you entered is incorrect.",
    "auth_user_changed": "Your account changed. The new password was not saved.",
    "auth_user_inactive": "This account is inactive or finished. Set it to active before sending a password reset.",
    "user_duplicate": "A user with this email or student ID already exists.",
    "too_early": "This session is not open for joining yet. Please try again in {{retry_after_seconds}} seconds.",
    "expired": "The join window for this session has closed.",
    "wrong_provider": "This session is not set up for in-app video. Use the meeting link from your calendar instead.",
    "session_already_ended": "You already completed this session.",
    "oral_exam_access_denied": "You do not have permission to join this session.",
    "oral_exam_booking_not_found": "No booking was found for this session.",
    "oral_exam_slot_not_found": "This session slot could not be found.",
    "invalid_state_transition": "That action is not available in the current exam state.",
    "question_pool_empty": "This task has no exam questions configured. Contact your administrator.",
    "etag_mismatch": "The exam session changed. Refresh and try again.",
    "if_match_required": "This action requires a fresh session state. Refresh and try again.",
    "late_join_cutoff": "The exam has already started; late join is not permitted.",
    "session_started_without_you": "This exam session started without you.",
    "start_gate_blocked": "The exam cannot start until all required ID checks are approved.",
    "session_cancelled_supervisor_absent": "This session was cancelled because no supervisor joined.",
    "session_cancelled_technical": "This session was cancelled due to a technical problem.",
    "oral_exam_task_not_found": "The exam task for this booking could not be found.",
    "examiner_superseded": "The examiner connection was replaced. Refresh and try again.",
    "oral_exam_grading_snapshot_missing": "Grading data for this exam is not available yet.",
    "oral_exam_practice_unavailable": "Oral exam practice is not available for this task.",
    "event_kind_immutable": "This event kind cannot be changed because the task is already in use. Add a new event task for a different format.",
    "module_already_in_course": "This module is already added to the course.",
    "membership": {
      "remove_student_title": "Remove Student from Course",
      "remove_student_message": "Removing a student from this course will result in the loss of all their progress, tasks and grades associated with this course. This action cannot be undone.",
      "remove_module_title": "Remove Module from Course",
      "remove_module_message": "Removing a module from this course will result in the loss of all student work, submissions and grades associated with this module in this specific course. This action cannot be undone.",
      "confirm_removal_title": "Final Confirmation Required",
      "confirm_removal_message": "Are you absolutely sure? All data related to this context will be permanently deleted.",
      "bulk_remove_students_title": "Remove Selected Students",
      "bulk_remove_modules_title": "Remove Selected Modules"
    }
  },
  "login": {
    "title": "Login",
    "welcome": "Welcome to {{displayName}}!",
    "initializing": "Loading...",
    "username": "Username",
    "password": "Password",
    "login-button": "Login",
    "stay-logged-in": "Stay logged in",
    "forgot-password": "Forgot password?",
    "errors": {
      "invalid-credentials": "Invalid username or password",
      "server-error": "Server error",
      "access-denied": "Access denied",
      "trial-expired": "Your trial period has expired. Please contact us to continue using the platform.",
      "missing-credentials": "Please enter your username and password",
      "error-loading-tenant-settings": "Could not load configuration, please check your internet connection and try again later.",
      "duplicate-email": "This email is associated with multiple accounts. Please use your username to log in instead."
    }
  },
  "forgot-password": {
    "title": "Reset Password",
    "description": "Enter your email address and we'll send you instructions to reset your password.",
    "email": "Email address",
    "submit": "Send Reset Instructions",
    "back-to-login": "Back to login",
    "success": "If an account exists with this email, you will receive password reset instructions shortly.",
    "errors": {
      "email-required": "Please enter your email address"
    }
  },
  "reset-password": {
    "title": "Set New Password",
    "description": "Please enter your new password.",
    "new-password": "New password",
    "confirm-password": "Confirm password",
    "submit": "Reset Password",
    "back-to-login": "Back to login",
    "success": "Your password has been reset successfully. You can now log in with your new password.",
    "errors": {
      "required": "This field is required",
      "password-length": "Password must be at least 8 characters long",
      "password-mismatch": "Passwords do not match",
      "invalid-token": "Invalid or expired reset token",
      "server-error": "Could not reset password. Please try again later.",
      "duplicate-email": "This email is associated with multiple accounts. Please contact support to reset your password.",
      "uppercase-required": "Password must contain at least one uppercase letter",
      "lowercase-required": "Password must contain at least one lowercase letter",
      "number-required": "Password must contain at least one number",
      "special-char-required": "Password must contain at least one special character"
    }
  },
  "grade": {
    "taskGradeLabel": "Grade",
    "transferTasks": "Feedback on Transfer Tasks",
    "regularTasks": "Feedback on Regular Tasks",
    "oralExam": {
      "sectionTitle": "Oral exam result",
      "overallAssessment": "Overall assessment",
      "overallJustification": "Overall justification",
      "additionalComment": "Additional comment",
      "lecturerComment": "Lecturer comment",
      "viewTranscript": "View transcript",
      "transcript": "Transcript",
      "noTranscript": "No transcript available",
      "performanceByArea": "Performance by area",
      "questionByQuestion": "Question-by-question feedback",
      "questionsHeading": "Per-Question Feedback",
      "questionNumber": "Question {{n}}",
      "questionFallback": "Question {{n}}",
      "rubricLabel": "Rubric detail",
      "noQuestionFeedback": "No written feedback for this question.",
      "noDimensionRating": "Not rated",
      "dimensions": {
        "content": {
          "title": "Content & Understanding",
          "description": "Mastery of core concepts and correct use of terminology"
        },
        "depth": {
          "title": "Depth & Critical Thinking",
          "description": "Explaining why and how, noting limitations and trade-offs"
        },
        "application": {
          "title": "Application & Synthesis",
          "description": "Connecting theory to examples, transfer to new contexts"
        },
        "communication": {
          "title": "Communication Clarity",
          "description": "Clear structure, concise sentences, well-paced delivery"
        },
        "professionalism": {
          "title": "Professionalism & Time Management",
          "description": "Confident delivery, staying within time, honest about gaps"
        }
      }
    },
    "playground": {
      "title": "Grade report playground",
      "hint": "Switch between representative grading scenarios to review layout and hierarchy.",
      "scenarioLabel": "Scenario",
      "entryLabel": "Grade report preview",
      "scenarios": {
        "essayClassic": {
          "label": "Essay classic",
          "description": "Transfer and regular essay tasks with the standard grade report layout."
        },
        "oralExamOnly": {
          "label": "Oral exam only",
          "description": "Single oral exam drives the module grade and should feel like one cohesive result."
        },
        "oralExamRich": {
          "label": "Oral exam rich",
          "description": "Full oral exam result with all questions rated and detailed feedback."
        },
        "oralExamSparse": {
          "label": "Oral exam sparse",
          "description": "Partial oral exam output with limited ratings and fallback text handling."
        },
        "mcqDelayed": {
          "label": "MCQ delayed",
          "description": "Delayed-feedback quiz result without essay or oral exam sections."
        },
        "mixed": {
          "label": "Mixed",
          "description": "Oral exam plus essay tasks in one module to verify section ordering."
        },
        "minimal": {
          "label": "Minimal",
          "description": "Module-level grading only, with no detailed per-task evaluation data."
        }
      }
    }
  },
  "common": {
    "jobs": {
      "title": "Background Jobs",
      "loading": "Checking...",
      "empty": "No active background jobs.",
      "failed": "Failed",
      "types": {
        "autograde": "Autograde",
        "bulk": "Bulk processing",
        "process_resource": "Process resource",
        "working_mode_apply": "Apply student working mode"
      },
      "workingModeApply": {
        "label": "Apply student working mode",
        "progressHint": "{{count}} steps in this apply",
        "summary": "{{failed}} of {{total}} steps failed",
        "successSummary_one": "{{count}} step completed",
        "successSummary_other": "{{count}} steps completed",
        "attempts_one": "{{count}} attempt",
        "attempts_other": "{{count}} attempts",
        "recovery": "Fix the listed tasks (title/description), then Module Settings → Review & apply to resume.",
        "ruleSteps": {
          "essay_objectives_present": "Objectives generation",
          "essay_rubric_present": "Rubric generation",
          "oral_question_pool_present": "Oral question generation"
        }
      }
    },
    "resolutionGuard": {
      "title": "Insufficient Resolution",
      "message": "This section needs a minimum screen resolution of {{width}}x{{height}}.",
      "currentResolution": "Current resolution: {{width}}x{{height}}"
    },
    "objective-dimensions": {
      "formal": "Formal Requirements",
      "description": "Scientific Description",
      "analysis": "Analytical Reflection",
      "application": "Practical Application",
      "content": "Content",
      "depth": "Depth",
      "communication": "Communication",
      "professionalism": "Professionalism"
    },
    "buttons": {
      "ok": "OK",
      "cancel": "Cancel",
      "back": "Back",
      "close": "Close",
      "retry": "Retry",
      "save": "Save",
      "submit": "Submit",
      "delete": "Delete",
      "discard": "Discard",
      "dismiss": "Dismiss",
      "paste": "Paste",
      "copy": "Copy",
      "show-more": "Show more",
      "show-less": "Show less",
      "logout": "Logout"
    },
    "labels": {
      "version": "Version {{version}}"
    },
    "components": {
      "modulePreview": {
        "header": {
          "title": "Readonly Preview",
          "defaultTitle": "Module",
          "close": "Close"
        },
        "navigation": {
          "course": "Course View",
          "module": "Module View",
          "task": "Task View",
          "diff": "Changes View"
        }
      }
    },
    "messages": {
      "error": "Something went wrong. Please try again."
    },
    "clipboard": {
      "copied": "Copied to clipboard",
      "copyFailed": "Failed to copy to clipboard"
    },
    "oralExamFacts": {
      "chipQuestions_one": "{{count}} question",
      "chipQuestions_other": "{{count}} questions",
      "chipMinutesEach": "{{count}} min each",
      "chipSecondsEach": "{{count}}s each",
      "chipClosedBook": "closed book",
      "chipRecorded": "recorded",
      "title": "About this exam",
      "showDetails": "How the exam works",
      "intro": "You answer questions out loud in an online meeting.",
      "processLead": "The exam is recorded and transcribed for later reference.",
      "para1_one": "You will then be asked one question drawn from the question pool below. You have {{perQuestionTime}} to respond - roughly {{totalMinutes}} minutes in total. Work through your answer completely; you will not be interrupted.",
      "para1_other": "You will then be asked {{count}} questions drawn at random from the question pool below, one after the other. You have {{perQuestionTime}} per question - roughly {{totalMinutes}} minutes in total. Work through each answer completely before moving on; you will not be interrupted.",
      "para1WithSubset_one": "You will then be asked one question drawn at random from the question pool below - review every question in the pool when preparing, since only this one will be asked live. You have {{perQuestionTime}} to respond - roughly {{totalMinutes}} minutes in total. Work through your answer completely; you will not be interrupted.",
      "para1WithSubset_other": "You will then be asked {{count}} questions drawn at random from the question pool below, one after the other - review every question in the pool when preparing, since only this draw will be asked live. You have {{perQuestionTime}} per question - roughly {{totalMinutes}} minutes in total. Work through each answer completely before moving on; you will not be interrupted.",
      "placeholderNote": "Some questions show a gap marker (…) in the sentence where you will be given a specific topic in the exam. Others use a quoted gap (\"…\") for wording you will comment on.",
      "para2": "For each question, make sure to address every aspect it raises: show a firm command of the underlying concepts and the depth you developed while working through the tasks. These questions are closely tied to your coursework, so the core knowledge is already there - take time to think through the specific angle each question opens up and how you would structure a clear, complete response.",
      "conduct": "This exam is closed-book. Speak your answers freely from your own understanding - do not read them from notes, a script, or a screen. You may use notes and the AI Tutor while you prepare; you may not use notes, AI, search, or any other aid during the exam itself.",
      "para3": "The format reflects real professional situations where you are asked to explain a concept, break it into its components, and support it with a concrete example - a skill as valuable as the knowledge itself.",
      "upToSecondsPerQuestion_one": "up to {{count}} second",
      "upToSecondsPerQuestion_other": "up to {{count}} seconds",
      "upToMinutesPerQuestion_one": "up to {{count}} minute",
      "upToMinutesPerQuestion_other": "up to {{count}} minutes",
      "attemptRules": {
        "show": "When an attempt counts",
        "countsHeading": "It counts as an attempt when:",
        "counts": {
          "started": "The exam starts for you, whether you complete it or end it early.",
          "notInLobbyReady": "You are not in the lobby with your check-in complete when the exam starts.",
          "dropped": "The exam ends because your connection, camera, microphone, or screen share drops for more than 60 seconds in total."
        },
        "notCountsHeading": "It does not count when:",
        "notCounts": {
          "cancelEarly": "You cancel at least 24 hours before the start time (after that, your registration is binding).",
          "ourSide": "The exam is cancelled or ends due to an issue on the university’s side.",
          "practice": "You take a practice run."
        },
        "written": "A previous graded written submission for this module counts as your first attempt."
      }
    },
    "errors": {
      "required": "This field is required",
      "minLength": "Must be at least {{count}} characters",
      "passwordMismatch": "Passwords do not match"
    },
    "edit": "Edit",
    "close": "Close"
  },
  "student": {
    "trial": {
      "readOnlyNotice": "A trial account cannot save work or register for a session."
    },
    "course": {
      "greeting": {
        "screentitle": "My Modules",
        "welcome": "Welcome back, {{name}}!"
      },
      "modulestages": {
        "current": "Current Module",
        "active": "Available Modules",
        "locked": "Upcoming Modules",
        "submitted": "Submitted for Evaluation",
        "graded": "Completed and Graded"
      },
      "modulecard": {
        "tasks": "Tasks",
        "lecturer": "Lecturer",
        "button-openmodule": "Open Module",
        "button-closemodule": "Close Module",
        "button-workonmodule": "Work on Module",
        "button-unlockmodule": "Unlock Module",
        "button-viewgrade": "View Grade",
        "grading-due-date": "Grading Due"
      },
      "open-module-dialog": {
        "title": "Switch to another module",
        "message": "You are currently working on '{{oldModuleTitle}}'.\nAre you sure you want to pause your work here (your progress will be saved) and switch to '{{newModuleTitle}}' instead?",
        "button-open": "Switch to new module",
        "button-cancel": "Stay with current module",
        "message-success": "You have switched your focus to '{{newModuleTitle}}'."
      },
      "locked-module-dialog": {
        "title": "Module Recommended Later",
        "message": "You selected module '{{moduleTitle}}' which belongs to a future segment. We strongly discourage jumping ahead – it's best to finish your current segment first to ensure a smooth learning journey. Only proceed if there's an exceptional reason.",
        "button-open": "I understand, open anyway",
        "button-cancel": "Back to current segment"
      },
      "errors": {
        "server-error": "Could not access list of modules, please check internet connection and try again later."
      }
    },
    "module": {
      "current-module": {
        "current-module-ects": " ({{ects}} ECTS)",
        "button-submit-module": "Submit Module"
      },
      "task-list": {
        "title": "Tasks",
        "level": "Level",
        "module-version-help-dialog": {
          "title": "Content Version",
          "description": "We're continuously improving and updating module content. This module is currently in version {{version}}. You'll see the latest content version until you start working on this module. In that moment we freeze the content for you, so you can work on a stable version basis.\n\nIn case of group work, please make sure all group members are working on the same version.",
          "confirm": "OK"
        }
      },
      "module-finished": {
        "title": "Module Complete",
        "message": "You have completed all tasks of this module. You can submit the module for evaluation and grading when you're ready.\nPlease note, that this cannot be undone. Your work will be evaluated and graded."
      },
      "task-overview": {
        "task-state": {
          "not-started": "Not started",
          "draft": "Draft with {{wordcount}} words",
          "done": "Marked as done"
        },
        "objectives": {
          "title": "Task Objectives",
          "not-applicable": "Not applicable"
        },
        "immutableDoneMessage": "This task was marked as done and cannot be edited or reopened.",
        "button-opentask": {
          "open-task": "Open Task",
          "view-task": "View Task",
          "reopen-task": "Reopen Task",
          "redo-quiz": "Redo Quiz"
        }
      },
      "task-detail": {
        "start-session": "Start Session",
        "book-session-first": "Book a session first to open this task."
      },
      "oralExamQuestionPool": {
        "titleWithCount_one": "Exam question pool — {{count}} question",
        "titleWithCount_other": "Exam question pool — {{count}} questions",
        "questionHeading": "Question {{index}} — {{title}}",
        "showAll": "Show all {{count}} questions",
        "showFewer": "Show fewer questions",
        "openAll": "Open all {{count}} questions",
        "lockOpen": "Questions can still change until you register for a session. After that, your question pool stays the same.",
        "lockRegistered": "This is your question pool for {{date}} at {{time}}. This question pool will not change.",
        "lockRegisteredNoDate": "This is the question pool for the session you registered for. This question pool will not change.",
        "poolLoadErrorTitle": "Could not load your question pool.",
        "poolLoadErrorBody": "Try again. If this keeps happening, please contact support.",
        "tryAgain": "Try again"
      },
      "task-sidebar": {
        "title": "Formal Requirements",
        "formal-requirements": "Formal Requirements",
        "activityMessage": "This task contains instructions for an activity. No evaluation is performed on this platform.",
        "completionPolicy": "Completion Policy",
        "completionPolicies": {
          "free": "You assess and decide, when to mark this task as done.",
          "gated": "Your work has to meet certain performance criteria, before you can mark this task as done."
        },
        "eventTitle": "Event",
        "eventMessage": "This task requires you to attend an event. Please register for a session, make sure your tech setup is working reliably and join 10 minutes early.",
        "oralExamCompletionPolicy": "The exam marks this task done when the sitting ends.",
        "oralExamCompletedMessage": "This exam is complete.",
        "grading-system-message": {
          "undefined": "N/A",
          "pass_fail": "This task will be evaluated and weighed as 'regular task'.",
          "full_evaluation": "This is a transfer work task and will be evaluated and weighed as such.",
          "plt": "You will receive instant feedback on your work when saving your task to help you improve your essay."
        },
        "target-wordcount": "Target Wordcount",
        "evaluation": "Evaluation",
        "mcqPassRequirement": "To pass: {{requiredCorrect}} of {{total}} correct ({{percent}}%).",
        "mcqPassRequirementPercentOnly": "To pass: {{percent}}%.",
        "oral-exam-module-message": "For this module, your performance will be evaluated in an oral exam. This task helps you prepare for the exam questions (see exam task description).",
        "timeLimit": "Time Limit",
        "timeLimitValue": "{{minutes}} minutes",
        "citations-requirement": "Citations requirement",
        "citations-required": "Citations and reference list required",
        "citations-not-required": "No citations and reference list required",
        "status": "Status",
        "state": "State",
        "progress": "Progress",
        "done": "Done",
        "in-progress": "In Progress",
        "wordCountValue_one": "{{count}} word",
        "wordCountValue_other": "{{count}} words",
        "wordCountTargetValue_one": "{{count}} word (+-{{tolerance}}%)",
        "wordCountTargetValue_other": "{{count}} words (+-{{tolerance}}%)"
      },
      "eventTask": {
        "checkingSlots": "Checking available slots...",
        "bookedLabel": "Booked",
        "awaitingConfirmation": "Awaiting confirmation",
        "awaitingConfirmationDetailed": "Please accept the calendar invite we sent you to confirm this appointment",
        "acceptInviteHelp": "Check your email for the Teams meeting invite",
        "havingTrouble": "Having trouble accepting the invite?",
        "manualConfirmExplain": "If you can't accept the calendar invite, you can confirm manually below",
        "confirmAttendanceButton": "Confirm My Attendance",
        "manualConfirmDialog": {
          "title": "Confirm your attendance?",
          "message": "Please only use this if you cannot accept the calendar invite. By confirming, you commit to attending this session."
        },
        "manualConfirmSuccess": "Attendance confirmed successfully",
        "manualConfirmError": "Failed to confirm attendance. Please try again.",
        "confirmedInstructions": "Meeting confirmed - you will receive further instructions",
        "chooseSlot": "Choose an available slot",
        "loadError": "Error loading slots",
        "noSlotsSupport": "No slots available. Contact {{email}} for support.",
        "placesLeft": "{{count}} places left",
        "bookButton": "Book Slot",
        "booking": "Booking...",
        "cancelButton": "Cancel Booking",
        "cancelRule": "You can cancel up to 24 hours before the meeting ({{hours}} hours remaining)",
        "cancelNotAllowed": "Cancellation not allowed (less than 24 hours until meeting)",
        "cancelTooLate": "Cannot cancel - less than 24 hours until meeting",
        "bookingSuccess": "Slot booked successfully",
        "bookingError": "Failed to book slot",
        "cancelSuccess": "Booking cancelled successfully",
        "cancelError": "Failed to cancel booking",
        "status": {
          "pending": "Pending",
          "confirmed": "Confirmed",
          "completed": "Completed"
        },
        "states": {
          "locked": "Locked - Complete required tasks first",
          "available": "Available for booking",
          "booked": "Booked - You have an appointment"
        },
        "locked": {
          "generic": "This task is currently locked. Complete the required tasks to unlock booking options.",
          "completePrevious": "Complete '{{taskTitle}}' first to unlock this event task.",
          "completeAllPrevious": "Complete {{count}} previous tasks to unlock this event task.",
          "allPreviousMustBeCompleted": "All previous tasks must be completed first ({{count}} remaining).",
          "completeSpecific": "Complete '{{taskTitle}}' to unlock this event task.",
          "completeMultipleSpecific": "Complete these tasks first: {{taskTitles}}"
        }
      },
      "upgrade-offer": {
        "ribbon-title": "New module version available",
        "ribbon-subline-oral-only": "Version {{version}} · graded by an oral exam",
        "review": "Review update",
        "modal-title": "A new version of this module is ready",
        "title-ai-tutor-essays": "Get AI Tutor feedback on your essays",
        "title-new-version": "A new version of this module is ready",
        "version-label": "You are on {{from}}, a newer {{to}} is ready",
        "what-you-get-heading": "What you get",
        "how-graded-heading": "How you are graded",
        "lecturer-note-heading": "Note from your lecturer",
        "summary-unavailable": "We could not load the details of this update. Ask your lecturer before updating.",
        "ai-tutor-essays": {
          "one": "AI Tutor feedback on your drafts for {{count}} essay task",
          "other": "AI Tutor feedback on your drafts for {{count}} essay tasks"
        },
        "finished-work-stays": "Your finished essays stay in the module",
        "grade-same-as-now": "Same as now: {{basis}}",
        "grade-now-label": "Now",
        "grade-after-label": "After the update",
        "oral-exam-only-note": "Your essays prepare you for it but no longer count toward the grade.",
        "type-label": {
          "essay": {
            "one": "{{count}} essay task",
            "other": "{{count}} essay tasks"
          },
          "oral_exam": {
            "one": "{{count}} oral exam",
            "other": "{{count}} oral exams"
          },
          "activity": {
            "one": "{{count}} activity task",
            "other": "{{count}} activity tasks"
          },
          "multiple_choice": {
            "one": "{{count}} quiz",
            "other": "{{count}} quizzes"
          },
          "event": {
            "one": "{{count}} event task",
            "other": "{{count}} event tasks"
          }
        },
        "added-type": {
          "essay": {
            "one": "{{count}} new essay task",
            "other": "{{count}} new essay tasks"
          },
          "oral_exam": {
            "one": "{{count}} new oral exam",
            "other": "{{count}} new oral exams"
          },
          "activity": {
            "one": "{{count}} new activity task",
            "other": "{{count}} new activity tasks"
          },
          "multiple_choice": {
            "one": "{{count}} new quiz",
            "other": "{{count}} new quizzes"
          },
          "event": {
            "one": "{{count}} new event task",
            "other": "{{count}} new event tasks"
          }
        },
        "whats-changing-heading": "What's changing",
        "task-changes-heading": "Task changes",
        "removed-tasks-heading": "Removed tasks",
        "added-tasks-heading": "Added tasks",
        "task-in-progress": "(in progress)",
        "removed-tasks-warning": "Work on removed tasks will not carry over to the new version.",
        "removed-tasks-with-progress-warning": "You have started work on tasks that will be removed. That progress will not carry over.",
        "acknowledge-task-changes": "I understand removed tasks will not carry over",
        "acknowledge-grade-change": "I understand my grade will come only from the oral exam.",
        "irreversible-warning": "This switch is permanent.",
        "accept": "Update to {{version}}",
        "accept-with-tutor": "Update to {{version}} and get AI Tutor feedback",
        "remind-later": "Not now",
        "hide-offer": "Don't show this again",
        "progress-warning": "Updating may reset progress on tasks that changed or were removed in the new version. Make sure you saved anything important before continuing.",
        "type-confirm": "Type UPGRADE to confirm",
        "success": "Your module was updated to the new version",
        "error": "We could not update your module. Please try again or contact support if this continues.",
        "dismiss-error": "We could not save your choice. Please try again."
      },
      "submit-module-dialog": {
        "title": "Submit Module",
        "complete-message": "Are you sure you want to submit this module for evaluation and grading? You cannot undo this step.\n\nBy submitting, you confirm that you have completed the work independently, without unauthorized assistance, and that you have used AI tools only within the permitted bounds and with appropriate referencing where required.",
        "incomplete-message": "Please complete all tasks of this module first, before you submit the module.",
        "success-message": "You have successfully submitted this module for evaluation and grading.",
        "error-message": "Something went wrong, we could not submit your module for evaluation and grading.",
        "button-submit": "Submit Module"
      },
      "feedback-dialog": {
        "title": "Congratulations!",
        "message": "You finished and submitted the module '{{title}}' successfully! We would very much appreciate, if you take 5 minutes of your time to provide some feedback.",
        "button-no": "Continue",
        "button-yes": "Give Feedback"
      },
      "messages": {
        "no-task-selected": "Please select a task from the list.",
        "no-module-selected": "No module selected, please pick a module to work on from the module screen."
      }
    },
    "grade": {
      "adminOverride": {
        "label": "Administratively recorded grade"
      },
      "versions": {
        "beforeThis": "Before this",
        "earlierExams": "{{count}} earlier exams",
        "current": "Current",
        "seeThisExam": "See this exam",
        "backToCurrentGrade": "Back to current grade",
        "writtenExam": "Task based evaluation",
        "oralExam": "Oral exam based evaluation",
        "yourCurrentGrade": "Your current grade",
        "earlierGrade": "Earlier grade",
        "gradedOn": "Graded {{date}}",
        "lookingBack": "You are looking back at an earlier exam.",
        "archiveLoadError": "We could not load that exam. Check your connection and try again.",
        "retry": "Try again",
        "accessibilityOpen": "Open {{kind}}, grade {{grade}}, {{date}}"
      }
    },
    "task": {
      "header": {
        "level": "Level"
      },
      "instructions": {
        "description-tab": "Task",
        "objectives-tab": "Objectives",
        "feedback-tab": "Feedback"
      },
      "evaluation": {
        "target-wordcount": "Target wordcount: "
      },
      "composer": {
        "wordcount": {
          "_comment": "Word count dialog message in composer",
          "words": "{{wordcount}}/{{target}} words",
          "title": "Word Count",
          "message": "Your document body contains {{bodyWords}} words, in total {{allWords}} words (including references).\nNote: Please prefix your literature reference list with a h1 headline titled 'References' or 'Works Cited', so counts are accurate."
        },
        "buttons": {
          "save": "Save Draft",
          "mark-as-done": "Mark as Done",
          "feedback": "Get Feedback",
          "history": "History",
          "reopen-to-edit": "Reopen to Edit"
        },
        "messages": {
          "placeholder": "Please start writing here...",
          "submission-save-success": "Your submission has been saved as draft.",
          "submission-save-submit-success": "Your submission has been saved and marked as 'done'.",
          "submission-save-error": "Save failed.",
          "submission-save-failed-dialog": "We could not save your current work. Please check your internet connection and try again.",
          "submission-save-error-offline": "You appear to be offline. Your changes cannot be saved. Please check your internet connection.",
          "submission-concurrent-error-title": "Sync Required: Updated Elsewhere",
          "submission-concurrent-error": "It looks like you have this task open in another window or session where changes were recently saved. To protect your work from being accidentally overwritten, we've paused autosaving. \n\nWhat to do now: \n1. Copy your latest changes in the editor. \n2. Refresh the page to get the latest version. \n3. Paste your changes back in. \n\nYour work is safe and previous versions are available in the History tab.",
          "submission-forbidden-error-title": "Permission Denied",
          "submission-forbidden-error": "You no longer have permission to edit this submission. The task may be already marked as done, the exam may be closed, or the deadline may have passed.",
          "submission-save-error-noimage-dialog": {
            "title": "Style Guide Note",
            "message": "Images are not allowed in your submission. Please remove images from the text, add them as attachments and try again."
          },
          "activity-composer": {
            "message": "This activity does not require any written input at this point."
          },
          "marked-as-done": "Marked as done"
        },
        "unsaved-dialog": {
          "title": "Unsaved changes",
          "message": "You have unsaved changes. Are you sure you want to leave this screen?",
          "button-stay": "Stay",
          "button-discard": "Discard"
        },
        "status": {
          "unsaved": "Unsaved changes...",
          "saving": "Saving...",
          "saved": "Saved"
        },
        "submission-noreferences-dialog": {
          "title": "Style Guide Warning: References section",
          "message": "Your submission contains no correctly formatted references section. If this is intentional, please continue.\n\nOtherwise please consider adding a 'h1' formatted headline titled 'References' or 'Works Cited' above your list of references.",
          "button-submit": "Submit Anyway",
          "button-cancel": "Cancel"
        },
        "submission-outside-wordcount-limits-dialog": {
          "title": "Style Guide Warning: Wordcount",
          "message": "Your submission contains {{wordcount}} word(s), which doesn't meet the task requirements (target: {{target}}, min: {{min}}, max: {{max}} words). Are you sure you want to submit it anyway?",
          "button-submit": "Submit Anyway",
          "button-cancel": "Cancel"
        },
        "submission-review-dialog": {
          "title": "Pre-submission Assistant",
          "intro": "I've done a quick scan of your submission to help you spot common oversights. Take a look at these points before you submit — they might help you better align with the formal guidelines:",
          "button-submit": "Submit Anyway",
          "button-edit": "Review and Edit"
        },
        "validation": {
          "wordcount-too-small": "Your text contains {{wordcount}} word(s), which is below the minimum requirement of {{min}}.",
          "wordcount-too-large": "Your text contains {{wordcount}} word(s), which exceeds the maximum limit of {{max}}.",
          "no-references": "It seems your references section is missing or not correctly labeled with a 'References' heading.",
          "refs-missing-citation": "Make sure you only list references that you actually cited in your text. We couldn't find an in-text citation for '{{author}}'.",
          "refs-composition-apa_one": "{{count}} line looks like an APA citation",
          "refs-composition-apa_other": "{{count}} lines look like APA citations",
          "refs-composition-other_one": "{{count}} line looks like other content",
          "refs-composition-other_other": "{{count}} lines look like other content",
          "refs-check-composition": "{{apaClause}} and {{otherClause}} — is that correct? Other content is fine for appendices or AI-tool notes if that is intentional.",
          "refs-check-apa-style": "Your reference section contains content that does not look like APA citations. If these are appendices or AI-tool notes, that may be fine — otherwise check your formatting.",
          "refs-check-apa-style-multiple": "{{otherCount}} lines in your reference section do not look like APA citations. If these are appendices or AI-tool notes, that may be fine — otherwise check your formatting."
        }
      },
      "attachments": {
        "menu": {
          "open": "Open in new tab",
          "download": "Download",
          "delete": "Delete attachment"
        },
        "no-attachments": "No attachments.",
        "no-attachments-interactive": "No attachments yet. Click here or drop files to upload. Allowed: {{types}}",
        "allowed-formats": "Allowed formats: {{types}}",
        "drop-zone-hint": "Drop files here to upload",
        "upload-success": "Attachment uploaded successfully",
        "upload-error": "Failed to upload attachment",
        "delete-success": "Attachment deleted successfully",
        "delete-error": "Failed to delete attachment"
      },
      "resourcePanel": {
        "title": "Resources",
        "loading-resources": "Loading resources...",
        "no-resources": "No resources available.",
        "errors": {
          "resource-url": "Invalid resource URL, cannot open resource.",
          "video-url-failed": "Failed to load video."
        },
        "buttons": {
          "copy-citation": "Copy citation",
          "open-in-new-tab": "Open in new tab",
          "open": "Open"
        }
      },
      "videoplayer": {
        "messages": {
          "no-transcript": "There is currently no transcript available for this video."
        }
      },
      "messages": {
        "no-task-selected": "No task selected."
      },
      "aiTutor": {
        "welcomeMessage": "Hello! I'm your AI tutor. Ask me questions about your task or submit your work for feedback.",
        "inputPlaceholder": "Ask tutor...",
        "emptyState": "No messages yet.",
        "feedback": {
          "title": "Feedback",
          "empty": "Press Evaluate to get focused guidance on your next best step.",
          "observationLabel": "Observation",
          "nextStepLabel": "Next best step",
          "helpfulPrompt": "Was this feedback helpful?",
          "helpfulYes": "Helpful",
          "helpfulNo": "Not helpful",
          "reasonPlaceholder": "Tell us in one short line why this was not helpful",
          "submitReason": "Send feedback",
          "submitError": "Could not send your feedback. Please try again."
        },
        "evaluationCard": {
          "title": "Evaluation Snapshot",
          "gradeLabel": "Grade",
          "totalScore": "Total score",
          "noEvaluation": "Ask the AI to evaluate your progress",
          "thresholdMessageMap": "Improvements required",
          "submitTask": {
            "title": "Submit Task",
            "message": "Are you sure you want to submit your task? You will not be able to edit your submission after that. This cannot be undone.",
            "submit": "Submit",
            "cancel": "Cancel"
          },
          "cachedEvaluationNotice": "Showing your most recent evaluation. Please continue editing your draft and try again after making more progress or waiting a few minutes.",
          "requiredLevelTooltip": "This task requires {{part}} to be at least level “{{level}}”.",
          "readyToSubmit": "Ready to submit",
          "notReadyToSubmit": "Not ready to submit",
          "evaluateAgain": "Evaluate again to check your changes"
        },
        "presenceBand": {
          "readingDraft": "Reading your draft",
          "followingLineOfThought": "Following your line of thought",
          "checkingPiecesConnect": "Checking how the pieces connect",
          "planningNextMove": "Planning your next move",
          "shapingClearSuggestion": "Shaping one clear suggestion",
          "takingLongerWithDraft": "Taking a little longer with this draft",
          "whatISee": "What I see",
          "ready": "Ready",
          "optionalPolish": "Optional polish",
          "suggestedNextStep": "Suggested Next Step",
          "feedbackReady": "Feedback ready",
          "evaluationFailed": "Evaluation didn't finish"
        },
        "clearHistory": {
          "title": "Delete conversation and reset evaluation?",
          "message": "Are you sure you want to delete this conversation and its evaluation?",
          "confirm": "Delete",
          "cancel": "Cancel"
        },
        "copiedToClipboard": "Conversation copied to clipboard",
        "copyFailed": "Failed to copy conversation",
        "clearFailed": "Failed to clear conversation",
        "clearTimeout": "Clear conversation timed out"
      },
      "versionHistory": {
        "title": "Version History",
        "loading": "Loading version history...",
        "error": "Failed to load version history. Please try again.",
        "empty": "No previous versions available",
        "emptyHint": "Versions are saved automatically as you write",
        "currentStatus": "Your current draft has {{count}} characters",
        "hint": "Select a version below to restore your work to that point",
        "versionLabel": "Version {{seq}}",
        "lastSaved": "Last saved",
        "characters": "characters",
        "vsCurrent": "vs current",
        "restore": "Restore",
        "preview": "Preview",
        "loadConfirm": {
          "title": "Load Previous Version?",
          "message": "Replace your current work with version from {{date}}? Your current draft will be saved as a new version in history.",
          "cancel": "Cancel",
          "confirm": "Load Version"
        },
        "loaded": "Version {{seq}} loaded. Changes will auto-save in a few seconds.",
        "loadError": "Failed to load version"
      },
      "feedback": {
        "evaluationTitle": "Your Performance",
        "streaming": "AI is still writing..."
      }
    },
    "eventTask": {
      "lockedMessage": "This event is locked until prerequisites are completed.",
      "registrationLockedMessage": "Registration unlocks after you complete previous tasks.",
      "chooseSession": "Choose an upcoming timeslot",
      "slotOption": "{{date}} at {{time}}{{spots}}",
      "timezoneLabel": "Timezone: {{tz}}",
      "registrationButton": "Register for Session",
      "registrationConfirmationTitle": "Confirm Registration",
      "registrationConfirmationBase": "You are about to register for {{date}} at {{time}}.\n\nPlease note: Once registered, you can cancel up to 24 hours before the session. After that, participation is mandatory.",
      "registrationRecordingNotice": "Notice: This session will be recorded for assessment, verification, and quality assurance purposes. Recordings are accessed only by authorized staff and retained only as long as necessary to handle queries, complaints, appeals, or legal obligations.",
      "abort": "Abort",
      "confirmRegistration": "Yes, Register",
      "registering": "Registering for session...",
      "registrationSuccess": "Session registered successfully",
      "registrationError": "Could not register for session. Please try again.",
      "cancelSuccess": "Registration cancelled",
      "cancelError": "Could not cancel registration. Please try again.",
      "cancelNotAllowed": "Registrations cannot be canceled within 24 hours of the session.",
      "registeredLabel": "Session Registration",
      "cancelButton": "Cancel Registration",
      "cancelling": "Cancelling...",
      "cancelConfirmationTitle": "Cancel Registration",
      "cancelConfirmation": "Are you sure you want to cancel your registration for {{date}} at {{time}}?",
      "cancelRule": "{{days}} days, {{hours}} hours before the meeting. You can cancel up to 24 hours before the meeting.",
      "loadError": "Failed to load available sessions.",
      "noSlots": "No sessions available right now.",
      "noSlotsSupport": "No upcoming sessions. If you think this is wrong, please contact support at {{email}}.",
      "checkingSlots": "Checking available sessions...",
      "awaitingConfirmation": "Awaiting confirmation - please check your email inbox and accept the Teams meeting invite to complete your registration.",
      "awaitingConfirmationDetailed": "Please accept the calendar invite we sent you to confirm this appointment",
      "acceptInviteHelp": "Check your email for the Teams meeting invite",
      "havingTrouble": "Having trouble accepting the invite?",
      "manualConfirmExplain": "If you can't accept the calendar invite, you can confirm manually below",
      "confirmAttendanceButton": "Confirm My Attendance",
      "manualConfirmDialog": {
        "title": "Confirm your attendance?",
        "message": "Please only use this if you cannot accept the calendar invite. By confirming, you commit to attending this session."
      },
      "manualConfirmSuccess": "Attendance confirmed successfully",
      "manualConfirmError": "Failed to confirm attendance. Please try again.",
      "confirmedInstructions": "Registration confirmed. Please join 10 minutes before the start to complete your check-in.",
      "completedInstructions": "Meeting completed. Thank you for your participation!",
      "joinTeamsMeeting": "Join Teams Meeting",
      "openTeamsSession": "Open Teams Session",
      "copyTeamsLink": "Copy Teams Link",
      "openMeetingSession": "Join Meeting",
      "copyMeetingLink": "Copy Meeting Link",
      "placesLeft_one": "{{count}} seat left",
      "placesLeft_other": "{{count}} seats left",
      "resources": {
        "title": "Event Materials",
        "oralExamTitle": "Materials",
        "noResources": "No materials available for this event"
      },
      "description": {
        "title": "Description",
        "additionalCommentsTitle": "Additional comments",
        "showMore": "Show more",
        "showLess": "Show less"
      },
      "status": {
        "pending": "Pending",
        "confirmed": "Confirmed",
        "completed": "Completed",
        "cancelled": "Cancelled"
      },
      "markDoneLink": "Skip event, mark as done",
      "markDoneConfirmTitle": "Skip event, mark as done?",
      "markDoneConfirmMessage": "You can undo this later.",
      "markDoneSuccess": "Marked as done",
      "markDoneError": "Could not mark as done",
      "proctoredSubmittedTitle": "Quiz already submitted",
      "proctoredSubmittedMessage": "You already submitted your quiz data for this proctored exam.",
      "preflight": {
        "title": "Exam status",
        "admissionWaiting": "Waiting for identity verification",
        "admissionHint": "Join the video call and have your ID ready.",
        "admissionDone": "Identity verified",
        "sessionNotStarted": "Exam not yet started",
        "sessionWaiting": "Waiting for lecturer to open exam",
        "sessionHint": "The lecturer will open the exam for all students shortly.",
        "sessionOpen": "Exam is open",
        "sessionPaused": "Exam session currently closed",
        "sessionPausedHint": "The lecturer may reopen the session. Please stay in the call.",
        "joinCall": "Join Video Call",
        "startQuiz": "Start Quiz",
        "startReady": "You can start the quiz now."
      }
    },
    "grading": {
      "levels": {
        "very_good": "Very Good",
        "good": "Good",
        "satisfactory": "Satisfactory",
        "sufficient": "Sufficient",
        "failed": "Failed"
      },
      "evaluationOverview": "Analysis of your performance across different dimensions.",
      "dimensionHints": {
        "formal": "Writing style, word count, citations, reference list, text body structure, and academic language",
        "description": "Clear explanation of concepts and theories related to the task",
        "analysis": "Critical evaluation and detailed examination of concepts",
        "application": "Practical application of theories in real-world scenarios",
        "reflection": "Personal insights and understanding of concepts' limitations"
      }
    },
    "mcq": {
      "submitQuiz": "Submit Answers",
      "questionNumber": "Question {{number}}",
      "explanation": "Explanation:",
      "questionsAnswered": "{{answered}} of {{total}} answered",
      "waitingForExam": "Waiting for Exam to Start",
      "joinMeetingFirst": "Please join the Teams meeting. The examiner will open the exam shortly.",
      "examClosed": "Exam has ended",
      "yourScore": "Your Score",
      "passed": "Passed",
      "failed": "Not Passed",
      "correctAnswer": "Correct Answer",
      "yourAnswer": "Your Answer",
      "timeRemaining": "Time Remaining: {{time}}",
      "timeUp": "Time is up! Your answers have been submitted.",
      "tryAgain": "Try Again",
      "markAsDone": "Mark as done",
      "needsBookingMessage": "You need to book a session before you can start this exam.",
      "waitingForAdmission": "Waiting for admission",
      "waitForLecturerVerification": "Please wait for lecturer verification before starting the quiz.",
      "backToModule": "Back to module",
      "loadingQuiz": "Loading quiz...",
      "loadFailed": "Failed to load quiz. Please try again.",
      "coldReplayFailed": "Could not restore your quiz results. Please try again.",
      "retry": "Retry",
      "autoSubmitted": "Time is up. Your answers have been automatically submitted.",
      "submittingAnswers": "Submitting your answers...",
      "noQuestions": "No questions available for this quiz.",
      "autoSubmitInProgress": "Time is up. Auto submit in progress.",
      "answerAllQuestions": "Answer all questions to submit the quiz.",
      "timeRunningOut": "Time running out. Please submit your answers soon.",
      "startedAt": "Started at {{time}}",
      "closesAt": "Closes at {{time}}",
      "examClosedTitle": "This exam has ended",
      "examClosedBody": "Submissions are no longer accepted.",
      "markingTaskDone": "Marking task as done...",
      "submissionSavedTitle": "Submission saved",
      "submissionSavedMessage": "Your answers were saved and this quiz is now marked as done.",
      "submissionSavedExamMessage": "Your answers have been submitted. Results will be available after the exam ends.",
      "submittedTitle": "Quiz submitted",
      "submittedMessage": "Your exam has been submitted successfully.",
      "timeoutSubmittedTitle": "Time is up",
      "timeoutSubmittedMessage": "Your latest answers were submitted automatically.",
      "finalizingSubmission": "Finalizing submission...",
      "backToCourse": "Go to course",
      "noFeedbackMessage": "Your answers have been recorded. You can now mark this task as done.",
      "markDoneError": "Could not mark task as done. Please try again.",
      "retakeDialog": {
        "title": "Take quiz again?",
        "message": "You already completed this quiz. Do you want to delete your previous answers and try again?",
        "confirm": "Take quiz again",
        "resetFailed": "Could not reset your previous attempt.",
        "preparing": "Preparing quiz..."
      }
    }
  },
  "lecturer": {
    "scheduledChanges": {
      "sidebarLabel": "Scheduled changes",
      "today": "Today",
      "title": "Scheduled changes",
      "count": "{{count}} changes",
      "upcoming": "Upcoming",
      "recent": "Recent",
      "recentHint": "last 30 days",
      "version": "Version {{version}}",
      "dateGoesLive": "Goes live {{date}}",
      "dateWentLive": "Went live {{date}}",
      "dateWasDue": "Was due {{date}}",
      "dateDraftReady": "Draft ready",
      "goLiveClock": "{{time}} {{zone}}",
      "emptyTitle": "No scheduled changes",
      "emptyBody": "When the platform prepares an update for one of your modules, it shows up here.",
      "loadError": "Couldn't load scheduled changes.",
      "retry": "Retry",
      "notFound": "This change isn't available.",
      "backToList": "Back to scheduled changes",
      "openVersion": "Open version {{version}}",
      "conflict": "This update changed or is going live.",
      "conflictHint": "We reloaded it. Swap again if it's still open.",
      "state": {
        "scheduled": "Scheduled",
        "draft_ready": "Draft ready",
        "applying": "Going live",
        "live": "Live",
        "failed": "Couldn't go live",
        "superseded": "Replaced by a newer version",
        "workingModeNotPublished": "Not published",
        "cancelled": "Cancelled"
      },
      "banner": {
        "scheduled": {
          "headline": "Goes live on {{date}} at {{time}} {{zone}} as a minor update of {{version}}",
          "sentence": "Nothing is required. Swap any question that doesn't fit before then. Students who already registered keep their questions."
        },
        "applying": {
          "headline": "Going live now as a minor update of {{version}}",
          "sentence": "Swapping is closed. This takes a few minutes."
        },
        "live": {
          "headline": "Live since {{date}} as version {{appliedVersion}}",
          "sentence": "These questions replaced the ones in {{version}}. Students who registered before keep their questions."
        },
        "failed": {
          "headline": "This update couldn't go live",
          "sentence": "Your current questions in {{version}} stay live. Nothing is required; we'll look into it."
        },
        "superseded": {
          "headline": "Replaced by a newer version",
          "sentence": "A newer version of this module was published before {{date}}, so this update was not applied. Your current questions stay live."
        },
        "cancelled": {
          "headline": "Cancelled",
          "sentence": "This update was cancelled before going live. Your current questions in {{version}} stay live."
        }
      },
      "workingMode": {
        "summary": "AI tutor + oral exam",
        "openDraft": "Open draft",
        "changes": {
          "progressionGated": "Progression: in order",
          "oralExamAdded": "Oral exam added",
          "aiTutorEssays_one": "AI tutor on for {{count}} essay",
          "aiTutorEssays_other": "AI tutor on for {{count}} essays"
        },
        "banner": {
          "scheduledOfferUpgrade": {
            "headline": "Goes live on {{date}} at {{time}} {{zone}}",
            "sentence": "The draft will go live as you leave it. Students still on version {{version}} will be invited to switch."
          },
          "scheduledNewVersion": {
            "headline": "Goes live on {{date}} at {{time}} {{zone}}",
            "sentence": "Only new students will get this version. Students already on version {{version}} stay there."
          },
          "draftReady": {
            "headline": "Draft ready",
            "sentence": "The draft is ready for you to publish. Students are not invited yet."
          },
          "liveOfferUpgrade": {
            "headline": "Live since {{date}} as version {{appliedVersion}}",
            "sentence": "Students on version {{version}} were invited to switch."
          },
          "liveNewVersion": {
            "headline": "Live since {{date}} as version {{appliedVersion}}",
            "sentence": "Only new students received this version; students on version {{version}} stayed there."
          },
          "supersededAuthor": {
            "headline": "Not published",
            "sentence": "You already sent the draft for approval, so the platform did not publish it."
          },
          "supersededRemoved": {
            "headline": "Draft removed",
            "sentence": "The draft was removed before go-live."
          }
        }
      },
      "oralQuestions": {
        "summary_one": "New oral-exam questions · {{count}} question",
        "summary_other": "New oral-exam questions · {{count}} questions",
        "meta": "{{questions}} questions in {{topics}} topics",
        "alternativesLeft_one": "{{count}} alternative left",
        "alternativesLeft_other": "{{count}} alternatives left",
        "topicCount_one": "{{count}} question",
        "topicCount_other": "{{count}} questions",
        "otherTopic": "Other",
        "emptyTopic": "No question of its own. Other topics filled its places."
      },
      "swap": {
        "button": "Swap",
        "alternatives_one": "{{count}} alternative",
        "alternatives_other": "{{count}} alternatives",
        "noneLeft": "No alternatives left",
        "title": "Swap this question",
        "current": "Current question",
        "pick": "Pick a replacement",
        "why": "Why doesn't it fit?",
        "reason": {
          "wrong_or_not_taught": "Wrong, or not what my course teaches",
          "unclear": "Unclear or hard to follow",
          "not_my_exam": "Not how I'd examine this",
          "other": "Something else",
          "resource_not_exam_relevant": "Underlying resource not exam relevant"
        },
        "toggleExamRelevance": "Toggle exam relevance for Resource '{{title}}'",
        "notePlaceholder": "Add a note (optional)",
        "noteRequired": "Tell us what's wrong (required)",
        "submit": "Swap question",
        "cancel": "Cancel",
        "error": "Couldn't swap the question. Check your connection and try again.",
        "success": "Question swapped"
      }
    },
    "engagement": {
      "filters": {
        "allModules": "All Modules",
        "allVersions": "All Versions",
        "workStateAll": "All States",
        "workStateActive": "Active",
        "workStateStalled": "Stalled"
      },
      "email": {
        "button": "Email all",
        "disabledNoModule": "Select a module to email students",
        "disabledNoRecipients": "No students with email addresses match the current filters",
        "disabledNoLecturerEmail": "Your account has no email address for composing mail",
        "subject": "Engagement — {{moduleTitle}}",
        "subjectWithVersion": "Engagement — {{moduleTitle}} (v{{moduleVersion}})",
        "greeting": "Dear students,\n\n",
        "openError": "Could not open your email app. Please try again."
      }
    },
    "taskTypes": {
      "multipleChoice": "Multiple Choice"
    },
    "resourceDigest": {
      "processing": "Preparing AI digest…",
      "ready": "AI digest ready",
      "examRelevant": "Exam relevant",
      "viewDigest": "View digest",
      "hideDigest": "Hide digest",
      "retry": "Retry",
      "retrying": "Retrying…",
      "notGenerated": "No AI digest yet",
      "notGeneratedHint": "This resource hasn't been read by the AI yet, so it won't be used for grading, rubrics or quiz generation until you generate a digest.",
      "generate": "Generate digest",
      "failedTitle": "The AI couldn't read this resource",
      "failedHint": "Its content won't be used for grading, rubrics or quiz generation.",
      "retryStarted": "Retrying — this can take a moment. Refresh to see the result.",
      "retryError": "Could not start reprocessing. Please try again.",
      "film": {
        "blocked": "YouTube doesn't let us read this film. Attach its transcript as a PDF document or pick another film.",
        "not_found": "This film is private or no longer exists. Update or remove the link.",
        "no_content": "We couldn't produce a summary of this film. Attach its transcript as a PDF document."
      },
      "reason": {
        "blocked": "The site blocked our reader (often bot protection or a paywall).",
        "not_found": "The page could not be found (404).",
        "unreachable": "The page could not be reached.",
        "timeout": "The site took too long to respond.",
        "unsupported_content": "This content type can't be read as text.",
        "no_content": "No readable text was found.",
        "error": "An unexpected error occurred while reading it."
      },
      "permanentHint": {
        "blocked": "Bot protection and paywalls can't be bypassed automatically. Consider linking to an open-access version.",
        "not_found": "This link leads to a page that no longer exists. Update or remove the URL.",
        "unsupported_content": "This link points directly to a file. Try re-adding it as a Document resource instead of a Link.",
        "no_content": "The page may load its text dynamically (JavaScript-rendered) and can't be read automatically."
      }
    },
    "preview": {
      "studentActionUnavailable": "Preview only — students can register and book sessions here.",
      "mcq": {
        "label": "Lecturer Preview",
        "toggleButton": "Preview Quiz Questions ({{count}})",
        "passThreshold": "Pass: {{percent}}%",
        "timeLimit": "{{minutes}} min",
        "shuffled": "Shuffled",
        "questionsSubset": "{{shown}} of {{total}} shown",
        "openQuiz": "Preview Quiz",
        "openProctoredQuiz": "Preview Proctored Quiz (bypasses exam session)",
        "resampleQuestions": "Resample Questions"
      },
      "aiTutor": {
        "runButton": "Run AI Tutor"
      }
    },
    "oralExamConfig": {
      "overridesTitle": "Overrides",
      "customizeToggleLabel": "Customize question pool size & exam settings",
      "poolSizeLabel": "Question Pool Size",
      "poolSizePlaceholder": "20",
      "questionCountLabel": "Questions Asked in Exam",
      "questionCountPlaceholder": "6",
      "secondsPerQuestionLabel": "Answer Duration per Question (s)",
      "secondsPerQuestionPlaceholder": "150",
      "poolTitle": "Question Pool",
      "poolEmpty": "No questions yet. Generate a pool, or add questions by hand.",
      "poolGeneratedAt": "Generated {{date}}",
      "poolLastEditedAt": "Edited {{date}}",
      "generateButton": "Generate",
      "regenerateButton": "Regenerate",
      "generating": "Generating questions...",
      "generateJobLabel": "Generate oral exam questions",
      "estimatedTime": "{{seconds}}s",
      "answerKeyTitle": "Answer Key Points",
      "answerKeyPoint": "Point",
      "answerKeyCriterion": "Criterion",
      "answerKeyAdd": "Add point",
      "provenanceFromTask": "Task · Level {{level}} · {{title}}",
      "provenanceFromTaskNoLevel": "Task · {{title}}",
      "provenanceFromResource": "Resource · {{title}}",
      "provenanceManual": "Added manually",
      "unknownTask": "Unknown task",
      "unknownResource": "Unknown resource",
      "savePool": "Save Pool",
      "discardPool": "Discard",
      "addQuestion": "Add question",
      "deleteQuestion": "Delete",
      "deleteQuestionTitle": "Remove this question?",
      "deleteQuestionMessage": "Are you sure you want to remove this question?",
      "questionLabel": "Question",
      "conceptLabel": "Concept",
      "bloomLabel": "Bloom level",
      "estTimeLabel": "Est. time (s)",
      "fillsTitle": "Interchangeable fills",
      "fillPlaceholder": "Noun phrase",
      "fillAdd": "Add fill",
      "fillErrorTooManyWords": "Max {{max}} words",
      "fillErrorTooManyCharacters": "Max {{max}} characters",
      "regenerateWithDirtyTitle": "Discard edits and regenerate?",
      "regenerateWithDirtyMessage": "You have unsaved edits. Regenerating will replace the entire pool with a new AI-generated set.",
      "regenerateConfirm": "Regenerate",
      "messages": {
        "configFailed": "Failed to save oral exam settings",
        "generateStarted": "Generating questions. Track progress in the header job tray.",
        "generateSuccess": "Question pool generated.",
        "generateFailed": "Failed to generate question pool. Please try again.",
        "poolSaved": "Question pool saved",
        "poolSaveFailed": "Failed to save question pool. Please try again."
      },
      "errors": {
        "mustBeNumber": "Must be a valid number",
        "questionCountRange": "Question count must be between 1 and 50",
        "secondsPerQuestionPositive": "Seconds per question must be a positive number"
      }
    },
    "mcq": {
      "addQuestion": "Add Question",
      "questionText": "Question Text",
      "optionText": "Option Text",
      "correctAnswer": "Correct Answer",
      "explanation": "Explanation (shown after answer)",
      "feedback": "Option Feedback",
      "passThreshold": "Pass Threshold",
      "shuffleQuestions": "Shuffle Questions",
      "shuffleOptions": "Shuffle Options",
      "timeLimit": "Time Limit (minutes)",
      "showImmediateFeedback": "Show Immediate Feedback",
      "addImage": "Add Image",
      "removeImage": "Remove Image",
      "imageAlt": "Image Description (for accessibility)",
      "mathPreview": "Math Preview",
      "difficulty": "Difficulty",
      "tags": "Tags",
      "proctored": {
        "openExam": "Open Exam",
        "closeExam": "Close Exam",
        "examOpen": "Exam is open",
        "examClosed": "Exam is closed",
        "timeRemaining": "Time Remaining",
        "participantsConnected": "Participants Connected"
      }
    },
    "sidebar": {
      "titles": {
        "meetingSlots": "Meeting Calendar",
        "modules": "Modules",
        "submissions": "Submissions",
        "tasks": "Tasks",
        "myModules": "My Modules",
        "assignedForEvaluation": "Assigned for Evaluation"
      }
    },
    "moduleMenu": {
      "gradeSubmissions": "Grade Submissions",
      "editModule": "Edit Module"
    },
    "moduleEditor": {
      "taskEditor": {
        "title": "Task Editor",
        "baseTab": "Description",
        "resourceTab": "Resources",
        "evalTab": "Evaluation",
        "gradingRubricTab": "Grading Rubric",
        "mcqTab": "Questions",
        "oralExamTab": "Exam Questions",
        "buttons": {
          "save": "Save",
          "delete": "Delete Task",
          "create": "Create Task",
          "move": "Move Task",
          "moveUp": "Move Up",
          "moveDown": "Move Down"
        },
        "saveRequired": {
          "title": "Save Required",
          "message": "You have changed the task type to {{type}}. Please save your changes before configuring specific settings."
        },
        "mcq": {
          "settingsTitle": "Quiz Settings",
          "passThreshold": "Pass Threshold",
          "shuffleQuestions": "Shuffle Questions",
          "shuffleOptions": "Shuffle Options",
          "showFeedback": "Show Immediate Feedback",
          "sampleQuestions": "Limit questions shown",
          "sampleQuestionsCount": "Number of questions",
          "proctoredMode": "Proctored Delivery",
          "proctoredDescription": "Require students to take this quiz during a scheduled exam session with proctor supervision.",
          "enableProctoring": "Enable Proctored Exam Mode",
          "proctoredUnlockPolicy": "Unlock policy is fixed to all previous tasks for proctored exams.",
          "timeLimit": "Time Limit (minutes)",
          "timeLimitPlaceholder": "optional",
          "questionsTitle": "Questions",
          "noQuestions": "No questions yet",
          "addFirstQuestion": "Add your first question to get started",
          "addQuestion": "Add Question",
          "adding": "Adding...",
          "saveSettings": "Save Settings",
          "saving": "Saving...",
          "newQuestionText": "New Question",
          "optionA": "Option A",
          "optionB": "Option B",
          "questionNumber": "Question {{number}}",
          "optionsCount": "{{count}} options",
          "explanationLabel": "Explanation",
          "deleteQuestionTitle": "Delete Question",
          "deleteQuestionMessage": "Are you sure you want to delete this question? This action cannot be undone.",
          "messages": {
            "settingsSaved": "MCQ settings saved successfully",
            "settingsFailed": "Failed to save MCQ settings",
            "questionSaved": "Question saved successfully",
            "questionFailed": "Failed to save question",
            "questionDeleted": "Question deleted successfully",
            "questionDeleteFailed": "Failed to delete question",
            "questionAdded": "Question added successfully",
            "questionAddFailed": "Failed to add question",
            "questionMoved": "Question moved"
          },
          "editQuestion": "Edit Question",
          "errors": {
            "passThresholdRange": "Pass threshold must be between 0 and 100%",
            "timeLimitPositive": "Time limit must be a positive number",
            "saveFailed": "Failed to save settings. Please try again.",
            "questionRequired": "Question text is required",
            "minOptions": "At least 2 options are required",
            "oneCorrect": "Exactly one correct answer is required",
            "optionRequired": "Option text is required"
          },
          "imageUpload": {
            "label": "Image",
            "labelOptional": "Image (optional)",
            "upload": "Upload Image",
            "delete": "Delete Image",
            "selected": "Selected: {{name}}",
            "uploading": "Uploading...",
            "uploadFailed": "Image upload failed. Please try again.",
            "invalidFormat": "Invalid file format. Only JPEG and PNG images are supported.",
            "fileTooLarge": "File size exceeds maximum limit of 5MB.",
            "selectFailed": "Failed to select file.",
            "confirmDeleteTitle": "Confirm Delete",
            "confirmDeleteBody": "Are you sure you want to delete this image?"
          }
        },
        "description": {
          "previewEyebrow": "Task description",
          "autoGeneratedBadge": "Auto-generated",
          "addAdditionalComments": "Add additional comments",
          "additionalCommentsLabel": "Additional Comments",
          "additionalCommentsPlaceholder": "Add a note only if there's something students should know beyond the details above."
        },
        "eventConfig": {
          "eventKind": "Event Kind",
          "kindSummary": "{{kindLabel}}: {{duration}} min, up to {{capacity}} students.",
          "customize": "Customize",
          "capacityLabel": "Max. Students",
          "durationLabel": "Duration (min)",
          "unlockWhen": "Unlock When",
          "requiredTasks": "Required Tasks",
          "unlockAlways": "Always available",
          "unlockAllPrevious": "if previous tasks are done",
          "proctoredUnlockPolicy": "Proctored exams always unlock after all previous tasks are done.",
          "durationOverrideHelperCompact": "Default {{defaultValue}}. Allowed: {{min}}-{{max}} min.",
          "capacityOverrideHelperCompact": "Default {{defaultValue}}. Allowed: {{min}}-{{max}} students.",
          "eventKindSticky": {
            "explanation": "This task already uses this event format. The event kind cannot be changed once the task is in use.",
            "recovery": "To offer a different format, add a new event task from the task list and choose the new event kind there."
          },
          "errors": {
            "eventKindRequired": "Event Kind is required",
            "unlockRequired": "Unlock condition is required",
            "mustBeNumber": "Must be a number",
            "durationMin": "Minimum {{min}}",
            "durationMax": "Maximum {{max}}",
            "capacityMin": "Must be at least {{min}}",
            "capacityMax": "Must be at most {{max}}"
          }
        },
        "messages": {
          "saveSuccess": "Task saved successfully.",
          "typeChangeRemintSuccess": "Task type changed — this version now uses a new task id. Your selection and unlock references were updated.",
          "saveError": "Cannot save task, please check all fields or contact support.",
          "readOnlySaveBlocked": "This task is read-only and cannot be saved. Reload the module or switch to a draft version.",
          "formError": "Cannot save task, please check all fields for errors.",
          "formErrorWithDetails": "Cannot save task: {{details}}",
          "deleteSuccess": "Task deleted successfully.",
          "deleteError": "Cannot delete task. Please try again or contact support.",
          "createError": "Cannot create task. Please try again or contact support.",
          "moveError": "Cannot move task. Please try again or contact support.",
          "rubricCopied": "Rubric copied to clipboard as CSV",
          "rubricCopyFailed": "Failed to copy rubric to clipboard"
        },
        "dialogs": {
          "deleteTask": {
            "title": "Delete Task",
            "message": "Are you sure you want to delete this task? This action cannot be undone."
          }
        },
        "taskEvalForm": {
          "labels": {
            "gradingRubric": "Grading Rubric",
            "reasoningFlowchart": "Student Reasoning Flowchart",
            "dimensionName": "Dimension Name",
            "points": "points",
            "pts": "pts",
            "criteria": "Criteria",
            "noCriteria": "No criteria defined yet",
            "criterionName": "Criterion Name",
            "description": "Description",
            "criticalCriterionExplanation": "{{dimensionName}} will be zeroed if this is not met"
          },
          "buttons": {
            "showReasoning": "Show Student Reasoning Path",
            "hideReasoning": "Hide Student Reasoning Path",
            "addCriterion": "Add Criterion",
            "edit": "Edit",
            "delete": "Delete",
            "makeCritical": "Mark as Critical",
            "removeCritical": "Remove Critical Mark"
          },
          "placeholders": {
            "criterionName": "Enter criterion name",
            "description": "Enter description of the criterion"
          },
          "tooltips": {
            "criticalCriterion": "Toggle critical criterion"
          },
          "errors": {
            "diagramError": "The reasoning diagram could not be rendered due to parsing errors."
          }
        },
        "header": {
          "objectType": "Task"
        }
      },
      "workingMode": {
        "fieldLocked": "Managed by working mode · {{mode}}. Switch to Custom to change.",
        "label": "Student working mode",
        "modes": {
          "custom": "Custom",
          "classicEssays": "Classic essays",
          "aiTutorOral": "AI Feedback & Oral Exam"
        },
        "badges": {
          "noPresetRules": "No preset rules",
          "savedNothingToChange": "Saved · nothing to change yet",
          "changesToApply": "{{count}} changes to apply",
          "readOnly": "Read-only",
          "inSync": "In sync",
          "versionLockedReadOnly": "{{state}} · read-only"
        },
        "descriptions": {
          "nothingToChange": "{{mode}} is saved. Everything you add from now on follows this mode.",
          "drifted": "{{mode}} governs this module and every new activity. Review what still needs to change.",
          "applying": "Applying your working mode. Follow progress in the job tray.",
          "inSync": "Module configuration matches {{mode}}.",
          "versionLocked": "Working mode changes on a draft."
        },
        "info": {
          "title": "What {{mode}} requires",
          "a11yLabel": "Show what {{mode}} requires",
          "rules": {
            "progressionFree": "Progression policy is Free",
            "progressionGated": "Progression policy is Gated",
            "autogradeOff": "Autograde on submit is Off",
            "autogradeOn": "Autograde on submit is On",
            "minLevelsTenantDefaults": "Minimum progression levels include Formal: Good (and tenant defaults for other dimensions)",
            "oralExamPresent": "An Oral Exam activity is present",
            "oralExamConfigured": "Oral exams use an Oral Exam event kind and unlock when previous tasks are done",
            "oralExamAbsent": "No Oral Exam activity",
            "oralQuestionsGenerated": "Oral exam questions are generated after essay rubrics",
            "gssPresentFree": "A group study session is present with Free completion",
            "gssPresentFreeLevel2": "At least one group study session (Free completion), as the last task of Level 2",
            "essaysAiTutor": "Every essay task has AI Tutor on (objectives and rubric generated if missing)",
            "essaysAiTutorOff": "AI Tutor is off for every essay task",
            "essayInheritPolicy": "Essay completion policy inherits from the module",
            "essayTransferTaskOff": "Grading Relevant (Transfer Task) is off for every essay"
          }
        },
        "states": {
          "applying": "Applying…"
        },
        "ledger": {
          "policies": "Module policies · {{count}} to change",
          "essays": "{{count}} essays · rubric → AI Tutor",
          "structureMissing": "Oral Exam & group study session missing"
        },
        "actions": {
          "reviewApply": "Review & apply ({{count}})",
          "tryAgain": "Try again"
        },
        "hints": {
          "saveFirst": "Save your changes first"
        },
        "messages": {
          "applySuccess": "Working mode applied.",
          "applyError": "Could not apply working mode.",
          "diffError": "Couldn't check this module."
        },
        "dialog": {
          "title": "Review & apply",
          "subtitle": "Move this module to {{mode}}",
          "phases": {
            "policies": "Module policies",
            "taskSettings": "Task settings to change",
            "essays": "Essay tasks"
          },
          "essayFootnote": "If an essay fails, it is retried once, then skipped. Failures show in the job tray; apply again to resume. The editor stays read-only until the job finishes.",
          "footerSummary": "Apply runs in order",
          "applyChanges": "Apply {{count}} changes",
          "checklist": {
            "progressionToGated": "Progression policy · {{current}} → {{desired}}",
            "progressionToFree": "Progression policy · {{current}} → {{desired}}",
            "autogradeOn": "Turn autograde on submit on",
            "autogradeOff": "Turn autograde on submit off",
            "minLevelsExplicit": "Set minimum progression levels to {{levels}}",
            "minLevelsFallback": "Set minimum progression levels to the tenant defaults",
            "addOralExam": "Add an Oral Exam activity",
            "configureOralExamOne": "Set Oral Exam event kind and unlock when previous tasks are done",
            "configureOralExamMany": "Set event kind and unlock-when-previous on {{count}} Oral Exam activities",
            "generateOralQuestions": "Generate oral exam questions",
            "removeOralExamOne": "Remove Oral Exam activity",
            "removeOralExamMany": "Remove {{count}} Oral Exam activities",
            "addGroupStudy": "Add a group study session (completion: Free)",
            "addGroupStudyLevel2": "Add a group study session as the last task of Level 2 (completion: Free)",
            "gssCompletionFreeOne": "Set group study session completion to Free",
            "gssCompletionFreeMany": "Set completion to Free on {{count}} group study sessions",
            "turnAiTutorOn": "Turn AI Tutor on for {{count}} essay tasks",
            "turnAiTutorOff": "Turn AI Tutor off for {{count}} essay tasks",
            "generateMissingRubrics": "Generate missing rubrics ({{count}})",
            "generateMissingObjectives": "Generate missing objectives ({{count}})",
            "essayInheritPolicy": "Reset essay completion policy to inherit module ({{count}})",
            "essayTransferTaskOff": "Turn Grading Relevant (Transfer Task) off for {{count}} essay tasks",
            "objectivesReady": "Task objectives ready for {{count}} essay tasks",
            "rubricsReady": "Rubrics ready for {{count}} essay tasks",
            "aiTutorReady": "AI Tutor already on for {{count}} essay tasks"
          }
        }
      },
      "moduleEditor": {
        "autogradeOnSubmission": {
          "label": "AUTO-GRADE ON SUBMIT",
          "description": "Automatically AI-grade all tasks when a student submits this module.",
          "off": "Off",
          "on": "On"
        },
        "examinationBasis": {
          "label": "EXAMINATION BASIS",
          "description": "Task submissions are a written exam. An oral exam is a spoken exam.",
          "taskSubmissions": "Task submissions",
          "oralExam": "Oral exam"
        },
        "buttons": {
          "save": "Save Module",
          "createModuleVersion": "Create New Version",
          "createVersion": "Create New Version",
          "deleteVersion": "Delete Version",
          "requestApproval": "Request Publication",
          "moduleSettings": "Module Settings",
          "preview": "Preview",
          "generateAllRubrics": "Generate missing rubrics"
        },
        "messages": {
          "saveSuccess": "Module settings saved successfully.",
          "saveError": "Cannot save module, please check all fields or contact support.",
          "formError": "Cannot save module, please check all fields for errors.",
          "publishSuccess": "Module published successfully.",
          "publishError": "Cannot publish module, please check all fields or contact support.",
          "createVersionSuccess": "New module version created successfully",
          "createVersionError": "Failed to create new module version: {{details}}",
          "deleteVersionSuccess": "Module version deleted successfully",
          "deleteVersionError": "Failed to delete module version: {{details}}",
          "generateAllRubricsNothingToDo": "All essay tasks already have a rubric.",
          "generateAllRubricsStarted": "Generating rubrics for {{count}} essay task(s). Track progress in the header job tray.",
          "generateAllRubricsSuccess": "Rubrics generated successfully for all eligible essay tasks.",
          "generateAllRubricsFailure": "Rubric generation failed. Check the job tray for details.",
          "generateAllRubricsInProgress": "AI is generating rubrics for this module. Editing is locked until the job completes.",
          "generateAllRubricsJobLabel": "Generate rubrics: {{moduleTitle}}",
          "mandateReadOnlyNotice": "You're viewing this module as an evaluator. Only the author can edit its content.",
          "versionLockedNotice": "This version is {{state}} and read-only. Create a new draft version to make changes."
        },
        "dialogs": {
          "generateAllRubrics": {
            "title": "Generate missing rubrics",
            "message": "Generate rubrics for {{count}} essay task(s) in \"{{moduleTitle}}\"? Missing objectives will be generated first. You can track progress in the header job tray."
          },
          "createVersion": {
            "title": "Create New Module Version",
            "message": "This will create a new version of the module based on the current version (version {{version}}). You can make changes to the new version without affecting the current version.",
            "loading": "Creating a new editable draft..."
          },
          "deleteVersion": {
            "title": "Delete Module Version",
            "message": "Are you sure you want to delete version {{version}} of this module? This action cannot be undone."
          },
          "requestApproval": {
            "title": "Request Approval for Module",
            "message": "This will request approval for this module to be published. Once approved, it will be available to be assigned to students.\n\nAre you sure you want to request approval?"
          },
          "initialPublish": {
            "title": "Publish Module First Version of the Module",
            "message": "This module has not yet been published. Publishing will make it available in courses for students to begin working on.\n\nOnce you request publication, no further changes can be made until the request has been reviewed and processed.\n\nDo you want to proceed with requesting approval to publish this module?",
            "optionRequestApproval": "Request Approval to Publish"
          },
          "requestApprovalOptions": {
            "title": "Request Approval for Module Publication",
            "intro": "Draft {{draftLabel}} is based on version {{sourceVersion}}. Choose how it goes live after approval.",
            "approvalTypeLabel": "How should this version be published?",
            "approvalTypeRequired": "Please choose how to publish this version",
            "submitButton": "Request approval",
            "optionReplaceVersionTitle": "Replace {{sourceVersion}} with {{replaceVersion}}",
            "optionReplaceVersionSubtitle": "Everyone on {{sourceVersion}} moves to {{replaceVersion}} automatically. The draft {{draftLabel}} is renumbered to {{replaceVersion}} on approval.",
            "optionNewVersionTitle": "Publish new version {{publishVersion}}",
            "optionNewVersionSubtitle": "Adds version {{publishVersion}} alongside older versions. New students get {{publishVersion}}; students on {{sourceVersion}} or older keep their current version.",
            "optionOfferUpgradeTitle": "Publish {{publishVersion}} with optional upgrade",
            "optionOfferUpgradeSubtitle": "Students on any older version can opt in to {{publishVersion}}. No one is moved automatically.",
            "changelogLabel": "Changelog comment (internal only)",
            "changelogPlaceholder": "Brief description of changes in this version",
            "changelogRequired": "Please provide a changelog comment",
            "offerStudentNoteLabel": "Note to students (optional)",
            "offerStudentNotePlaceholder": "Why you made this change — students see it as \"Note from your lecturer\"",
            "previewHeading": "What students see",
            "previewUnavailable": "Preview unavailable. Students will still see the computed changes.",
            "previewRetry": "Retry",
            "previewLoading": "Loading student preview…",
            "previewEmpty": "No older published version to preview."
          },
          "approvalRequested": {
            "title": "Approval Requested",
            "message": "The module \"{{title}}\" has been submitted with request for approval. You will be notified on approval or rejection."
          },
          "unsavedChanges": {
            "title": "Unsaved Changes",
            "message": "You have unsaved changes. Do you want to discard them?",
            "discard": "Discard Changes"
          }
        },
        "labels": {
          "moduleTitle": "Module \"{{title}}\""
        },
        "versionSelector": {
          "versionNumber": "Version {{version}} ({{state}})",
          "versionNumberWithSource": "Version {{version}} ({{state}}), based on {{sourceVersion}}",
          "triggerWithSource": "{{version}} · based on {{sourceVersion}}",
          "selectVersion": "Select version to edit",
          "states": {
            "published": "Published",
            "draft": "Draft",
            "pending_approval": "Pending Approval",
            "retired": "Retired"
          }
        },
        "header": {
          "objectType": "Module"
        }
      }
    },
    "evalDesk": {
      "taskGradeColumn": "Grade",
      "hideAiTutoredLabel": "Hide AI-tutored & event tasks",
      "submissionLoadError": "Failed to load submission.",
      "submissionPermissionDenied": "You do not have permission to view this submission.",
      "noTasksMatchFilter": "No tasks match the current filter.",
      "noTasksMatchFilterHint": "AI-tutored and pure event tasks are hidden. Toggle the switch in the header to show them.",
      "regenerateButton": "Regenerate",
      "regenerateSuccess": "Module summary regenerated",
      "regenerateError": "Failed to regenerate module summary",
      "defaultModuleFeedback": "<p>Please see details at each task.</p>",
      "defaultModuleFeedbackOralExam": "<p>Performance was assessed in the oral exam. See detailed feedback per question.</p>",
      "autoGradeComputeError": "Could not compute module grade. Check that tasks are fully evaluated.",
      "autoGradePendingSave": "Module grade is still calculating. Wait for the grade to appear before saving.",
      "incompleteSubmitTitle": "Evaluation incomplete",
      "incompleteSubmitMessage": "Task \"{{taskTitle}}\" is missing a rating for {{dimension}}.",
      "submitErrorContext": "Submit evaluation to student",
      "gradingDimHints": {
        "formal": "Wordcount, accurate academic language, correct citations, organization in paragraphs and headlines, spelling",
        "description": "Accurate and clear description of concepts, theories, or processes related to the task, reflects foundational understanding of the subject matter",
        "analysis": "Breakdown of the concepts or theories into constituent parts for detailed examination and/or critically evaluate importance, implications etc., this reflects the student's ability to critically evaluate and understand the intricacies of the topic",
        "application": "Methodical application and transfer of theoretical concepts in practical or hypothetical scenarios, reflects the student's ability to transfer academic knowledge to real-world contexts",
        "reflection": "Meta-analysis of the learning process, description of the applicability and limitations of concepts, personal insights or challenges, reflects if student established a personal connection with material",
        "content": "Accurate, on-topic answer that demonstrates relevant knowledge and clear understanding of the question",
        "depth": "Goes beyond surface-level facts: explains underlying mechanisms, trade-offs, and connections between concepts",
        "communication": "Clear structure, precise language, audience-appropriate framing, well-paced delivery",
        "professionalism": "Composure, ethical conduct, role-appropriate behavior and engagement during the exam"
      },
      "gradedAt": "Graded at",
      "justificationTooltip": {
        "expected": "Expected",
        "issue": "Issue"
      },
      "oralExam": {
        "summaryLabel": "Overall summary",
        "questionFeedbackLabel": "Feedback",
        "spokenAnswerLabel": "Spoken answer",
        "promptVersionLabel": "Prompt version",
        "evaluatedAtLabel": "Evaluated at",
        "questionFallbackTitle": "Question {{id}}",
        "showFullQuestion": "Show full question",
        "noAnswerRecorded": "No answer recorded"
      }
    },
    "assessmentPool": {
      "drawerTitle": "Oral Exam Question Pool",
      "personalizedTitle": "Personalized Exam Pool for {{name}}",
      "generateButton": "Generate Questions",
      "generating": "Generating...",
      "difficulty": {
        "label": "Difficulty Level",
        "foundational": "Foundational",
        "advanced": "Advanced",
        "expert": "Expert"
      },
      "instructions": {
        "label": "Custom Instructions",
        "placeholder": "e.g. Focus on ethics and application..."
      },
      "count": {
        "label": "Question Count"
      },
      "pool": {
        "empty": "No questions generated yet. Adjust settings and click generate.",
        "concept": "Concept",
        "bloom": "Cognitive Level",
        "estimatedTime": "{{seconds}}s",
        "answerKey": "Answer Key Points"
      }
    },
    "eventCalendar": {
      "gaps": {
        "title": "Planning Gaps",
        "unmet_one": "{{count}} Missing Slot",
        "unmet_other": "{{count}} Missing Slots",
        "unmetMessage": "Please schedule time slots for the following mandates:",
        "missingSlotsCount_one": "{{count}} slot",
        "missingSlotsCount_other": "{{count}} slots",
        "missingSeatsCount_one": "{{count}} seat",
        "missingSeatsCount_other": "{{count}} seats",
        "missingSegment": "Missing: {{period}}",
        "missingSegments": "Missing: {{periods}}",
        "missingIn": "Missing in: {{periods}}",
        "firstSegmentMissing": "First time period must be scheduled",
        "insufficientCoverage": "Not enough timeslots available"
      },
      "tabTitle": "Event Task Meetings",
      "title": "Timeslots for Event Task Meetings",
      "addSlot": "Create Meeting Slot",
      "createSlotPlaceholder": "Slot creation form coming soon",
      "capacity": "Capacity",
      "goToNow": "Today",
      "windowLoadError": {
        "message": "Could not load this calendar period.",
        "retry": "Retry"
      },
      "sidebar": {
        "createTitle": "Create Meeting Slot",
        "editTitle": "Edit Meeting Slot",
        "delete": "Cancel Slot",
        "pickTime": "Choose start and end time",
        "startTime": "Start Time",
        "duration": "Duration",
        "minutes": "minutes",
        "maxStudents": "Max. # of students",
        "restrictSwitch": "Restrict to specific tasks?",
        "createSuccess": "Slot created successfully",
        "updateSuccess": "Slot updated successfully",
        "deleteSuccess": "Slot deleted successfully",
        "deleteConfirm": "Are you sure you want to delete this slot?",
        "deleteConfirmWithRegistrations": "This slot has {{count}} registrations which will be cancelled. Are you sure you want to delete it?",
        "confirmBookingSuccess": "Booking confirmed manually",
        "meetingInfo": "Meeting Information",
        "registration": "Registration",
        "registrations": "Registrations",
        "meetingId": "Meeting ID",
        "joinUrl": "Join URL",
        "moderatorUrl": "Moderator URL",
        "platform": "Platform",
        "noRegistrations": "No registrations yet",
        "selectEventKindFirst": "Please select an event kind first",
        "noCompatibleTasks": "No compatible tasks found for the selected event kind",
        "examSession": "EXAM SESSION",
        "examOpen": "Open",
        "examClosed": "Closed",
        "examLocked": "Locked",
        "openQuiz": "Open Quiz",
        "reopenQuiz": "Reopen Quiz",
        "closeQuiz": "Close Quiz",
        "openingQuiz": "Opening Quiz...",
        "closingQuiz": "Closing Quiz...",
        "quizClosedFinal": "Quiz Closed",
        "preflightModalTitle": "Pre-flight Check-in",
        "preflightModalDescription": "Select students who may access the quiz in this session.",
        "preflightNoRegistrations": "No active registrations for this slot.",
        "preflightSelectedCount_one": "{{count}} selected",
        "preflightSelectedCount_other": "{{count}} selected",
        "preflightStartQuiz": "Start Quiz",
        "preflightReopenQuiz": "Reopen Quiz",
        "openQuizErrorTitle": "Open Quiz",
        "closeQuizErrorTitle": "Close Quiz",
        "admitted": "Admitted",
        "notAdmitted": "Not admitted",
        "admit": "Admit",
        "revoke": "Revoke",
        "status": {
          "pending": "Pending",
          "confirmed": "Confirmed",
          "completed": "Completed",
          "cancelled": "Cancelled"
        },
        "buttons": {
          "no_keep_it": "No, Keep it",
          "joinMeeting": "Join Meeting",
          "copyId": "Copy ID"
        },
        "sections": {
          "tasks": "TASKS",
          "modules": "MODULES"
        },
        "moreModules": "+{{moreCount}} more",
        "plannedSlotNote": "Please accept the Teams meeting invite to confirm this slot as available to students",
        "havingTroubleConfirming": "Having trouble confirming?",
        "manualConfirmExplain": "If the automatic confirmation via Teams invite fails, you can manually confirm the slot here.",
        "confirmSlotManual": "Confirm Slot Manually",
        "confirming": "Confirming...",
        "confirmSlotSuccess": "Slot confirmed successfully",
        "creatingSlot": "Creating slot...",
        "deletingAndCancellingInvites": "Cancelling invites...",
        "parametersFromTask": "Duration and capacity are resolved from the selected task configuration.",
        "parametersFromEventKind": "Duration and capacity are inherited from the event kind defaults.",
        "taskParameterConflict": "Selected tasks use conflicting duration or capacity settings. Choose tasks with matching values.",
        "rescheduleOpen": "Reschedule",
        "rescheduleTitle": "Reschedule",
        "rescheduleDate": "Date",
        "rescheduleDateFormat": "YYYY-MM-DD",
        "rescheduleButton": "Reschedule Slot",
        "rescheduling": "Rescheduling...",
        "rescheduleSuccess": "Slot rescheduled successfully",
        "rescheduleErrorTitle": "Reschedule Slot",
        "rescheduleConfirmTitle": "Reschedule slot?",
        "rescheduleConfirm": "Move this slot to the new date and time?",
        "rescheduleConfirmWithRegistrations": "{{count}} registered students will keep their booking and be notified."
      },
      "status": {
        "planned": "Planned",
        "available": "Open for Registration",
        "completed": "Completed"
      },
      "error": {
        "pastSlot": {
          "title": "Cannot Create Slot",
          "message": "You cannot create slots in the past. Slots must be at least 1 hour in the future."
        }
      },
      "summerTime": "Summer Time",
      "winterTime": "Winter Time",
      "validTimesSimple": "Valid times: {{times}}",
      "validTimesWithDst": "Valid times: {{times}} ({{dstLabel}})",
      "legend": {
        "available": "Available",
        "planned": "Planned",
        "full": "Full"
      },
      "errors": {
        "mustStartAtOrAfter": "Start must be at or after {{start}}",
        "mustEndByWindow": "End must be by {{end}}"
      },
      "email": {
        "menuLabel": "Email students",
        "emailAll": "Email All Students ({{count}})",
        "emailTask": "Email {{task}} Group ({{count}})",
        "greeting": "Dear Students,",
        "multipleModules": "Multiple Modules",
        "unassigned": "Flex Session"
      }
    }
  },
  "admin": {
    "forms": {
      "saveError": "Please fix the errors in the form before saving.",
      "saveErrorWithDetails": "Cannot save {{record}}: {{details}}"
    },
    "assistant": {
      "title": "Assistant",
      "placeholder": "Ask about users, courses, modules…",
      "send": "Send",
      "thinking": "Thinking…",
      "activity": {
        "toolCall": "Running tool",
        "toolResult": "Tool result",
        "toolGroup": "Tools used",
        "contextRefreshed": "context refreshed"
      },
      "confirm": {
        "title": "Confirm change",
        "sample": "Sample: {{sample}}",
        "action": "Confirm"
      }
    },
    "navigation": {
      "title": "Administration",
      "people": "People",
      "users": "Users",
      "cohorts": "Cohorts",
      "content": "Content",
      "courses": "Courses",
      "modules": "Modules",
      "workflows": "Workflows",
      "approvals": "Approvals",
      "reports": "Reports",
      "submissions": "Submissions",
      "gradingStats": "Grading Statistics",
      "aiTutor": "AI Tutor"
    },
    "reports": {
      "filters": {
        "gated": "Gated",
        "ungated": "Ungated",
        "from": "From",
        "to": "To",
        "dateRangeLast90Days": "Last 90 days · {{range}}",
        "dateRangeCustom": "{{range}}",
        "datePlaceholder": "YYYY-MM-DD",
        "excludePasteHeavy": "Leave out paste-heavy sessions",
        "excludeFirstTryPasses": "Leave out first-try passes",
        "filterSettings": "Filter settings"
      }
    },
    "analytics": {
      "scopeCount": "{{sessions}} finished sessions · {{students}} students",
      "empty": {
        "message": "No finished sessions match these filters."
      },
      "error": {
        "message": "Could not load analytics for these filters."
      },
      "retry": "Retry",
      "resetFilters": "Reset filters",
      "tutorHealth": {
        "heading": "Tutor health"
      },
      "releaseLegend": {
        "release": "New release"
      },
      "releaseLineLabel": "New release · {{prompt}}",
      "tooltip": {
        "sampleSize": "n = {{n}}",
        "sparklinePoint": "Week of {{week}} · {{value}} · n = {{n}}"
      },
      "aiTutor": {
        "title": "AI Tutor",
        "subtitle": "How students use the Draft Coach check, and whether each release helps.",
        "attempts": {
          "label": "Attempts to get done",
          "unit": "attempts",
          "caption": "Median per finished session"
        },
        "scoreGain": {
          "label": "Score gain per attempt",
          "caption": "Change from one attempt to the next"
        },
        "helpfulShare": {
          "label": "Helpful share",
          "caption": "{{voteRate}}% of hints rated"
        },
        "pasteHeavyShare": {
          "label": "Paste-heavy share",
          "caption": "Counted before the paste switch"
        },
        "stuckStudents": {
          "label": "Stuck students",
          "caption": "Over 10 attempts, not done, last one failed"
        }
      },
      "scoreProgression": {
        "heading": "Score progression",
        "legendMedian": "Median score",
        "legendBand": "Middle 60% of sessions (20th–80th percentile)",
        "axisAttempt": "Attempt number",
        "axisSessionWeek": "Week of session",
        "axisLabel": "Score (% of pass mark)",
        "axisLabelRubric": "Score (rubric %)",
        "passLine": "Pass",
        "tooltipScoreLine": "Score {{score}}% · {{count}} sessions"
      },
      "feedbackHelpfulness": {
        "heading": "Feedback helpfulness",
        "legendHelpful": "Helpful",
        "legendNotHelpful": "Not helpful",
        "legendVoteRate": "Vote rate (right axis)",
        "reasonsEmpty": "No thumbs-down reasons",
        "reasonsCollapsedShow": "Thumbs-down reasons · {{count}} reasons · Show",
        "reasonsCollapsedHide": "Thumbs-down reasons · {{count}} reasons · Hide",
        "reasonLine": "{{label}} · {{count}}",
        "reasonsLoading": "Loading thumbs-down reasons…",
        "reasonsError": "Could not load thumbs-down reasons.",
        "reasonsRetry": "Retry",
        "reasonsShowMore": "Show {{count}} more",
        "reasonRowMeta": "{{student}} · {{module}} · {{task}} · {{date}}",
        "unknownStudent": "Unknown student",
        "unknownModule": "Unknown module",
        "unknownTask": "Unknown task",
        "checkModal": {
          "loading": "Loading this check…",
          "error": "Couldn't load this check.",
          "retry": "Retry",
          "close": "Close",
          "gone": "This check is no longer stored.",
          "reasonHeading": "Reason",
          "draftHeading": "Draft at this check",
          "draftNotKept": "The draft for this check was not kept.",
          "commentHeading": "Tutor's comment",
          "nextStepLabel": "Next step",
          "commentNotKept": "No tutor comment was stored for this check."
        }
      }
    },
    "gradingStats": {
      "title": "Grading Statistics",
      "exportCsv": "Export CSV",
      "filters": {
        "from": "From (inclusive)",
        "to": "To (inclusive)",
        "apply": "Apply range",
        "lecturer": "Lecturer",
        "lecturerPlaceholder": "Filter by name"
      },
      "columns": {
        "lecturer": "Lecturer",
        "month": "Month",
        "total": "Total graded",
        "withOralExam": "With oral exam",
        "withoutOralExam": "Without oral exam"
      }
    },
    "impersonation_active": "You are currently impersonating {{user}}",
    "workflow": {
      "approvalTypes": {
        "new_version": "New Version",
        "publish_initial": "Publish Initial",
        "replace_version": "Replace Version",
        "offer_upgrade": "Offer Upgrade"
      }
    },
    "moduleApprovals": {
      "loading": {
        "approve": "Publishing this version...",
        "reject": "Rejecting this version...",
        "replaceVersion": "Publishing and upgrading students to the new version. This may take a moment."
      }
    },
    "gradeOverride": {
      "setTitle": "Set grade",
      "overwriteTitle": "Overwrite grade",
      "setAction": "Set grade",
      "overwriteAction": "Overwrite grade",
      "setRowAction": "Set grade",
      "overwriteRowAction": "Overwrite grade",
      "cancelAction": "Cancel",
      "gradePlaceholder": "Select grade",
      "commentPlaceholder": "e.g. Oral exam held manually in Teams on 12 Oct 2026",
      "notifyLine": "The student is notified and sees this grade and comment.",
      "historyLine": "The current grade stays in the history as attempt {{attempt}}.",
      "conflictError": "This submission has changed. The table will refresh — close the dialog and try again.",
      "saveError": "Could not save the grade. Check your connection and try again."
    },
    "userDetails": {
      "triggerReset": "Trigger Password Reset Email",
      "resetTriggered": "Password reset email triggered successfully",
      "setPassword": "Set Password",
      "setPasswordTitle": "Set User Password",
      "setPasswordSuccess": "User password set successfully",
      "newPassword": "New Password",
      "confirmPassword": "Confirm Password",
      "externalStudentId": "External Student ID",
      "externalStudentIdPlaceholder": "e.g. A5-12345"
    },
    "modulePreview": {
      "versionComparison": "Version Comparison",
      "comparingVersions": "Comparing version {{source}} to version {{target}}",
      "moduleChanges": "Module Changes",
      "taskChanges": "Task Changes",
      "resourceChanges": "Resource Changes",
      "field": "Field",
      "before": "Before",
      "after": "After",
      "change": "Change",
      "resource": "Resource",
      "details": "Details",
      "added": "Added",
      "removed": "Removed",
      "modified": "Modified",
      "newTask": "New Task",
      "removedTask": "Removed Task",
      "taskAdded": "Task \"{{name}}\" was added",
      "taskRemoved": "Task \"{{name}}\" was removed",
      "diffNotAvailable": "No previous version available for comparison",
      "noChangesDetected": "No changes detected between versions"
    },
    "common": {
      "references": {
        "searchPlaceholder": "Search…",
        "noResults": "No matches.",
        "retry": "Search failed. Tap to retry.",
        "remove": "Remove",
        "unknownLabel": "Unknown ({{id}})"
      }
    },
    "course": {
      "enrollments": {
        "extras": {
          "label": "Extra modules",
          "help": "This student sees every module on the course, plus any extras you pin here.",
          "empty": "No extra modules. This student sees the full course catalog.",
          "searchPlaceholder": "Search published modules…",
          "onCourse": "Already on this course",
          "noResults": "No published modules match.",
          "unpin": "Remove extra module",
          "count": "{{count}} extra"
        },
        "errors": {
          "addStudent": "Add Student"
        }
      },
      "modules": {
        "settings": {
          "assignment_title": "Course Assignment",
          "segment_label": "Segment",
          "segment_placeholder": "Select segment",
          "segment_required": "Segment assignment is required",
          "overload_toggle": "Overload module default ECTS/Workload?",
          "ects_label": "ECTS",
          "workload_label": "Workload",
          "meeting_types_title": "Meeting Entitlements",
          "personnel_title": "Responsible Personnel",
          "evaluation_label": "Evaluation",
          "loading": "Loading configuration..."
        },
        "errors": {
          "membershipAction": "Membership Operation",
          "updateSegment": "Update Segment"
        }
      }
    }
  },
  "maintenance": {
    "warning": "System will be unavailable today for planned system maintenance: {{start}} - {{end}} (approx. {{duration}} hours)",
    "active_message": "The system is currently under maintenance from {{start}} to {{end}}. {{message}}",
    "system_unavailable": "We're working on improving the system and will be back shortly.\nThank you for your patience.",
    "unavailable": {
      "title": "System Maintenance",
      "message": "We're currently conducting system maintenance to improve the system for you.\nMaintenance is scheduled from {{start}} to {{end}}."
    },
    "active": {
      "title": "System Maintenance",
      "message": "We're currently conducting system maintenance to improve the system for you.\nMaintenance is scheduled from {{start}} to {{end}}."
    },
    "ignored": {
      "title": "Maintenance Mode Ignored",
      "message": "System maintenance is currently active but being ignored. Some features may be unavailable or unstable."
    },
    "imminent": {
      "title": "Imminent System Maintenance",
      "message": "Warning: System maintenance will begin in 2 minutes. You will be automatically logged out when maintenance starts.\n\nPlease save your work and finish any ongoing tasks.\n\nMaintenance is scheduled from {{start}} to {{end}}."
    }
  },
  "oralExam": {
    "fillSlot": {
      "mark": "…",
      "a11y": "A specific topic you will be given in the exam"
    },
    "fillKind": {
      "case": "Company",
      "kind": "System type",
      "scene": "Situation",
      "problem": "Problem",
      "locus": "Phase",
      "specimen": "Example"
    },
    "joinRoom": "Join oral exam room",
    "joinLobby": "Join lobby",
    "mobileAppNotice": {
      "title": "Join this exam from a computer",
      "body": "Oral exams use live camera and microphone sharing that is only supported in a web browser. Please open this task on a computer using Chrome, Safari, or Firefox — the app cannot be used to join."
    },
    "beforeExam": {
      "title": "Before your exam",
      "joinBy": "Join the lobby by {{joinBy}} with a photo ID (passport, driving licence, student ID or similar), on a computer with a camera and microphone, in a quiet room.",
      "joinEarly": "Join the lobby 10 minutes early with a photo ID (passport, driving licence, student ID or similar), on a computer with a camera and microphone, in a quiet room.",
      "checkIn": "Complete check-in before the scheduled start time: take a photo of your ID and your face, then watch a short orientation video. If the exam starts without a completed check-in, it is recorded as a failed attempt.",
      "dryRunBefore": "If this is your first oral exam, you can ",
      "dryRunLink": "try a dry run",
      "dryRunAfter": " to check your camera, microphone and ID photos and answer two questions on your own. Nothing is graded.",
      "prepare": "Prepare your answers to the exam questions.",
      "openQuestions": "See the exam questions"
    },
    "taken": {
      "title": "You have taken this exam",
      "body": "The exam questions are no longer shown.",
      "back": "Back to the module"
    },
    "registration": {
      "title": "Your registration",
      "completed": "Completed",
      "attendedOn": "You attended on {{date}}.",
      "cancelled": "Your registration for {{date}} was cancelled. Choose a new session."
    },
    "booking": {
      "joinOpensAt": "The lobby opens at {{time}}.",
      "examStartedLocked": "You can no longer join this session",
      "examStartedLockedHint": "The join window has closed. You do not need to contact anyone. Non-attendance will be processed shortly, and then you can register for another session.",
      "examStartedWithoutYou": "This exam session started without you",
      "examStartedWithoutYouHint": "The exam started without you. This counts as an attempt.",
      "briefingStartedWithoutYouTitle": "This sitting is starting without you",
      "briefingStartedWithoutYouHint": "This sitting is starting without you because your check-in was not accepted. This attempt counts.",
      "examNotReadyAtStartTitle": "You were not ready when the exam started",
      "examNotReadyAtStartHint": "You were not ready when the exam started. This attempt counts and there is no grade.",
      "examInProgress": "This session is currently in progress",
      "examInProgressHint": "The join window has closed. You do not need to contact anyone. Non-attendance will be processed after the session ends, and then you can register for another session.",
      "statusInProgress": "In progress",
      "universityDifficultyTitle": "Sorry, there is a difficulty on our end",
      "universityDifficultyHint": "Please reschedule. This does not count as an attempt.",
      "examMissed": "You can no longer join this session",
      "examMissedHint": "The join window has closed. You do not need to contact anyone. Non-attendance will be processed shortly, and then you can register for another session.",
      "statusJoinClosed": "Join closed",
      "sessionAlreadyEnded": "You already completed this session",
      "sessionAlreadyEndedHint": "This oral exam session is finished. Book a new appointment if you need another attempt."
    },
    "connecting": "Connecting to the meeting room...",
    "loadingState": "Loading exam state...",
    "joinFailed": "Could not join the exam room. Try again or contact support.",
    "pollReconnecting": "Reconnecting to server…",
    "openElsewhere": {
      "title": "This exam is open in another window.",
      "useThisWindow": "Use this window"
    },
    "supervisorLeave": {
      "title": "Leave the exam?",
      "stay": "Stay",
      "leaveExam": "Leave exam",
      "leaveAnyway": "Leave anyway",
      "stepBackError": "Couldn't step back from the student. Check your connection, or leave anyway.",
      "messageOneToOne": "The student's exam keeps running and you can rejoin from your calendar.",
      "messageGroupCovered": "{{names}} will keep supervising, so the students' exams carry on. You can rejoin from your calendar or the invite link.",
      "messageGroupLast": "You're the last supervisor. If no supervisor rejoins within {{duration}}, every student's exam ends and they must rebook. You can rejoin from your calendar or the invite link.",
      "messageGroupShort": "This exam needs {{required}} supervisors. If there are still fewer than {{required}} in {{duration}}, every student's exam ends and they must rebook. You can rejoin from your calendar or the invite link.",
      "durationMinutes": "{{minutes}} minutes",
      "durationOneMinute": "1 minute",
      "durationSeconds": "{{seconds}} seconds"
    },
    "errorState": {
      "retry": "Try again",
      "leave": "Leave",
      "joinFailedTitle": "Could not join the exam room",
      "stateLoadFailedTitle": "Could not load exam state",
      "stateLoadFailedBody": "We lost contact with the server. Try again.",
      "liveKitConnectFailedTitle": "Could not connect to the exam room",
      "liveKitConnectFailedBody": "We could not establish a live connection. Try again or leave and rejoin from your bookings.",
      "leaveBriefing": "Leave briefing",
      "unknownStateTitle": "Waiting for the exam",
      "unknownStateBody": "This is taking longer than expected. You can leave and rejoin from your bookings."
    },
    "cameraDenied": "Camera access is required to join the exam.",
    "mediaBothRequired": "You must share both your camera and microphone. Audio-only is not allowed.",
    "mediaBlockedHelpLead": "Your browser saved Deny for this site and will not ask again. Remove {{host}} from the camera and microphone block list, then tap Retry.",
    "mediaBlockedHelpChrome": "Chrome: Settings → Privacy and security → Site settings → Camera (or Microphone) → remove {{host}} from Not allowed (or set to Allow).",
    "mediaBlockedHelpSafari": "Safari: address bar → this website’s settings (lock or aA) → Camera and Microphone → Ask or Allow. Or Safari → Settings → Websites → Camera → change {{host}} from Deny to Ask or Allow.",
    "micDenied": "Microphone access is required to join the exam.",
    "micBlockedHelp": "Your browser is blocking the microphone. Allow microphone access for this site in your browser settings, then tap Retry microphone.",
    "retryMedia": "Retry microphone",
    "retryCamera": "Retry camera",
    "staleStateToast": "Your view was out of date — refreshed.",
    "staleRetry": "The session changed — please try ending the exam again.",
    "actionFailed": "Something went wrong. Please try again.",
    "examStillPaused": "The exam is still paused for another reason — resume or resolve that first, then try again.",
    "clockPaused": "Clock paused",
    "takeOverRequired": "Take over from the AI examiner first, then try again.",
    "questionPoolEmpty": "This task has no exam questions configured. Contact your administrator.",
    "preStartTitle": "Drawn questions (pre-start)",
    "draftQuestionNumber": "Question {{index}}",
    "questionListItem": "Question {{index}}: {{id}}",
    "redraw": "Redraw",
    "startExam": "Start exam",
    "nextQuestion": "Next Question",
    "endExam": "End exam",
    "endExamConfirmTitle": "End exam?",
    "endExamConfirmMessage": "This ends the conference and submits the student's work for grading.",
    "abortExam": "Abort Exam",
    "abortConfirmTitle": "Abort exam?",
    "abortConfirmMessage": "This ends the session for the student. They can book another slot later.",
    "abortConfirmMessageCommitted": "This submits the student's work for grading with the answers recorded so far.",
    "runAgain": "Restart Exam",
    "runAgainConfirmTitle": "Run exam again?",
    "runAgainConfirmMessage": "This clears the current exam results and draws a fresh set of questions. The student will see the pre-start state.",
    "resetTimer": "Reset timer",
    "resetTimerConfirmTitle": "Reset the timer?",
    "resetTimerConfirmMessage": "The student gets the full answering time again for this question.",
    "repeatPreviousQuestion": "Repeat previous question",
    "repeatPreviousQuestionConfirmTitle": "Discard the previous answer?",
    "repeatPreviousQuestionConfirmMessage": "This student goes back to the last question. Their previous answer to that question will be discarded, and the answering timer starts again.",
    "dropInNextConfirmTitle": "Move on to the next question?",
    "dropInNextConfirmMessage": "Once you leave the student, the AI examiner asks it.",
    "oneToOne": {
      "waitingTitle": "You're connected",
      "waitingBody": "Waiting for your supervisor to start the exam. The first question will appear here.",
      "examNotStarted": "Exam not started"
    },
    "peerGone": {
      "student": {
        "title": "Your supervisor left the room",
        "body": "If they don't return, we'll close the exam."
      },
      "lecturer": {
        "studentLeftTitle": "Student left",
        "studentLeftBody": "We'll close the exam if they don't return."
      },
      "closingExam": "Closing exam…",
      "closingSeconds": "{{seconds}}s",
      "completeFailed": "Could not close the exam. Try again.",
      "retryClose": "Try again"
    },
    "answerKeyLabel": "Answer key",
    "questionTimer": "Time for this question: {{time}}",
    "noCurrentQuestion": "No question active",
    "terminalCompleted": "Exam completed. You may leave the room.",
    "terminalAborted": "Exam aborted. You may leave the room.",
    "leaveExam": "Leave exam",
    "leaveRoom": "Leave room",
    "lateSupervisor": {
      "title": "This exam already started",
      "body": "You were not in the room when it started, so you cannot join now."
    },
    "studentWaitingTitle": "Waiting for the exam to start",
    "studentWaitingBody": "Your supervisor will begin the exam shortly. Stay in the room with your camera and microphone ready.",
    "sessionExpiredTitle": "This exam session has closed",
    "sessionExpiredBody": "The scheduled time for this exam has passed, so it can no longer be resumed. Please contact your supervisor to arrange a new session.",
    "supervisorMessageLabel": "Message from your supervisor",
    "studentCurrentQuestionLabel": "Current question",
    "getReady": {
      "title": "Get ready",
      "body": "The AI examiner is about to begin — listen for the first question."
    },
    "studentTerminalCompleted": "The exam has ended. Thank you for participating.",
    "studentTerminalAborted": "This exam was aborted and counts as a failed attempt.",
    "studentDone": "I'm done",
    "requestHelp": "Request help",
    "studentPaused": "Exam paused ({{reason}})",
    "timerDuringReading": "Answer timer starts after the AI examiner finishes reading",
    "preReadCountdown": "Look at the question. Answering time starts in {{seconds}}",
    "countdownAnsweringHint": "Answer time remaining",
    "doneAnswering": "Done answering",
    "doneNextQuestion": "Done",
    "doneWaitingForReading": "Unlocks after the AI examiner finishes reading the question.",
    "doneAcknowledged": "Got it — one moment",
    "needHelp": "Need help",
    "student": {
      "abort": {
        "title": "Abort exam?",
        "confirmBody": "Aborting a running exam counts as a failed attempt. Are you sure?",
        "confirmBodyCommitted": "Aborting now submits what we have so far for grading. Are you sure?",
        "confirmBodyPractice": "Abort this dry run? Nothing was graded and no record will be kept.",
        "confirm": "Abort exam",
        "cancel": "Cancel"
      },
      "runtimeJourney": {
        "movingToExamRoom": {
          "title": "Moving you to your exam room"
        },
        "reconnecting": {
          "title": "Reconnecting to your exam room"
        },
        "waitingForExaminer": {
          "title": "Preparing your oral exam",
          "body": "The AI examiner is joining your room."
        },
        "examinerPreparing": {
          "title": "Preparing your oral exam",
          "body": "The AI examiner is preparing your first question."
        },
        "lecturerPreparing": {
          "title": "Your supervisor is preparing your exam"
        }
      },
      "examShell": {
        "welcome": "Welcome, {{firstName}}",
        "studentFallback": "student",
        "waitingSubcopy": "The AI examiner is joining. Start unlocks once the handshake completes.",
        "readySubcopy": "The AI examiner is ready. Start when you are.",
        "confirmingHandshakeSubcopy": "The AI examiner is connected — confirming handshake…",
        "startingSubcopy": "Starting…",
        "startExam": "Start exam",
        "startingFooter": "Starting…",
        "waitingForExaminerHint": "Waiting for the AI examiner…",
        "startFailed": "Could not start the exam. Try again."
      },
      "betweenQuestions": {
        "title": "Wrapping up",
        "pausedHint": "Your timer is paused."
      },
      "examinerReconnecting": {
        "title": "Reconnecting",
        "body": "Your answers are saved and your timer is paused."
      },
      "examEndedConnection": {
        "title": "Sorry, there is a difficulty on our end",
        "body": "Please reschedule. This does not count as an attempt."
      },
      "sessionVoidTechnical": {
        "title": "This session is no longer valid",
        "body": "Unfortunately this session is invalid due to technical difficulties. Your session is cancelled. Please register for another session.",
        "bodyWithSupport": "Unfortunately this session is invalid due to technical difficulties. Your session is cancelled. Please register for another session. If problems persist, please reach out to {{supportEmail}}."
      },
      "pendingClose": {
        "title": "Waiting for the session to end",
        "body": "Your answers are in. The supervisor will close the session shortly."
      },
      "lastQuestionWrap": {
        "title": "You're finished — wait for your supervisor",
        "body": "Your answers are in. Your supervisor will close the session when ready."
      },
      "presence": {
        "listening": "Listening",
        "speaking": "Speaking",
        "thinking": "Thinking…",
        "ready": "Ready",
        "error": "Reconnecting…"
      },
      "fault": {
        "failoverBanner": "The AI examiner has stepped aside — your supervisor is now supervising your exam.",
        "practiceAgentBanner": "The AI examiner didn't join. Leave and try the dry run again.",
        "reconnectedBanner": "You're back online — your answers are saved. Continue when you're ready.",
        "recordingInterruptedBanner": "Recording was interrupted. The exam can continue."
      },
      "examinerUnavailable": {
        "title": "Examiner unavailable",
        "body": "The AI examiner is not responding right now. Ask for help or abort the exam.",
        "hardStopBody": "The AI examiner did not join in time. Leave and rejoin from your bookings, or ask your supervisor for help.",
        "railHint": "Ask for help or abort below."
      }
    },
    "stageGate": {
      "ok": "Ready",
      "inconsistentInExamPreStart": {
        "title": "Exam did not start cleanly",
        "body": "The exam was marked started but your session never began. Ask your supervisor to reset so you can complete setup from the beginning."
      },
      "blocked": {
        "title": "Cannot continue right now",
        "body": "This exam step is not available yet. Leave and rejoin, or contact your supervisor."
      }
    },
    "statusRecording": "Recording",
    "statusRecordingRestarting": "Restarting recording",
    "statusConnected": "Connected",
    "questionProgress": "Question {{current}} of {{total}}",
    "supervisorStatusHereWithYou": "Here with you",
    "supervisorStatusEngaged": "Engaged",
    "supervisorStatusWatching": "Watching",
    "supervisor": {
      "yourSupervisors": "Your supervisors",
      "engagedPauseCue": "Exam is paused. Nothing you say now is part of the exam."
    },
    "examRoomTitle": "Exam room",
    "studentRoomTitle": "Oral exam with {{name}}",
    "studentSharedScreenLabel": "{{name}}'s shared screen",
    "sharedScreenLabel": "Shared screen",
    "awaitingStudentVideo": "Waiting for the student's camera",
    "lobby": {
      "header": "Lobby — get ready",
      "supervisorFallback": "Your supervisor",
      "welcome": {
        "title": "Let's get you ready for your oral exam",
        "subtitle": "A few quick steps before we begin — it takes about a minute.",
        "beginSetup": "Begin set-up",
        "zoomBanner": "Your browser zoom may hide buttons on this page. For the best experience, reset zoom to 100% (Ctrl+0 on Windows, Cmd+0 on Mac).",
        "idReady": "Have your photo ID ready (passport, driving licence, student ID).",
        "preview": {
          "consent": "Review and accept consent",
          "conduct": "Confirm exam code of conduct",
          "screenShare": "Share your screen",
          "device": "Turn on your camera & mic",
          "identity": "Take photos of your ID and your face",
          "waiting": "Wait for your supervisor to start",
          "waitingSelfService": "Start when you are ready"
        }
      },
      "steps": {
        "device": "Camera & mic",
        "consent": "Consent",
        "conduct": "Code of conduct",
        "screenShare": "Share your screen",
        "identity": "Identity check",
        "orientation": "Orientation",
        "waiting": "Waiting room"
      },
      "orientation": {
        "title": "Watch the orientation",
        "body": "A short film on how your oral exam runs. This is the last step before you wait for your supervisor.",
        "reviewNote": "Your supervisor is reviewing your photos while you watch.",
        "loading": "Loading your orientation film…",
        "loadFailed": "We couldn't load the orientation film.",
        "loadFailedBody": "Nothing you need to do — you can carry on to the waiting room.",
        "continue": "Continue",
        "saveRetry": "Still saving — retrying…",
        "continueAnyway": "Continue anyway",
        "skipAndRetake": "Skip and retake photo",
        "reject": {
          "lead": "Your supervisor needs a new identity photo.",
          "paused": "The film is paused until you choose.",
          "fixNow": "Fix my photo now",
          "finishFirst": "Finish orientation first",
          "reminder": "Photo retake needed — you go straight to the camera when the film ends or you skip."
        }
      },
      "device": {
        "title": "Turn on your camera & microphone",
        "grantedTitle": "Check your camera & mic",
        "primingBody": "Your browser will ask for permission — that's your browser's own security check, not us. Choose Allow: the exam can't run without your camera and microphone.",
        "enableButton": "Turn on camera & mic",
        "waiting": "Waiting for your browser…",
        "privacyNote": "Nothing is shared or recorded yet.",
        "privacyNoteGranted": "This is just you. Nothing is shared or recorded yet — check you look and sound right.",
        "previewPlaceholder": "Your camera preview will appear here.",
        "cameraOff": "Camera is off — turn it on to preview.",
        "continue": "Looks good — continue",
        "blockedLead": "Your browser is blocking your camera and microphone for this site, and may not ask again.",
        "blockedFix": "Click the padlock to the left of the web address → set Camera and Microphone to Allow → then Try again.",
        "blockedConsequence": "The exam cannot go ahead without camera and microphone.",
        "tryAgain": "Try again",
        "moreHelp": "More help",
        "leaveExam": "Leave exam",
        "recArmed": "Rec armed",
        "recArmedA11y": "Recording armed, not yet recording",
        "cameraPillLabel": "Camera",
        "micPillLabel": "Microphone",
        "defaultCamera": "Camera",
        "defaultMic": "Microphone",
        "audioPrompt": "Say something…",
        "audioConfirmed": "We can hear you ✓"
      },
      "consent": {
        "title": "Before we begin — your consent",
        "intro": "This exam is recorded and conducted with an AI-assisted format. Your supervisor may watch live.",
        "scope": {
          "camera": "Your camera feed",
          "microphone": "Your microphone audio",
          "screen": "Your screen (shared in the next step)",
          "recording": "Recording retained per exam policy"
        },
        "affirmation": "I consent to being recorded (camera, microphone and screen) and to the AI-assisted format.",
        "accept": "I consent"
      },
      "screenShare": {
        "title": "Share your screen",
        "body": "Your supervisor needs to see your screen for the whole exam, so your work is visible and the exam stays fair. If your screen share or connection is lost for more than one minute in total during the exam, the session is void — it does not count and you will need to rebook.",
        "placeholder": "Choose what to share when prompted.",
        "start": "Share screen",
        "change": "Change shared screen",
        "confirmTitle": "Screen shared",
        "confirmBody": "Your screen is shared with your supervisor.",
        "continue": "Continue",
        "webOnly": "Screen sharing is available in the web app."
      },
      "waiting": {
        "title": "Waiting for your supervisor",
        "body": "You're all set. Your supervisor will begin the exam shortly — please stay on this screen.",
        "checklist": {
          "camera": "Camera & microphone",
          "consent": "Recording consent",
          "screenShare": "Screen sharing",
          "identity": "Identity verified",
          "identityPending": "Identity — awaiting review"
        },
        "waitingForExaminer": "Waiting for your supervisor to begin...",
        "graceStayGroup": "Your supervisor can wait for other students until {{graceEndTime}}. Please stay on this page.",
        "graceStayOneToOne": "Your supervisor will start shortly. Please stay on this page.",
        "hintEyebrow": "Tip",
        "scheduledStart": "Scheduled start {{time}}",
        "leaveConfirm": {
          "title": "Leave the waiting room?",
          "message": "If you're not back and ready when the exam starts, you can't take part. This counts as an attempt.",
          "confirm": "Leave",
          "cancel": "Stay"
        },
        "defaultHints": {
          "coverParts": {
            "title": "Answer every part",
            "body": "If the question has more than one ask — what, why, an example — hit each part. Stopping after the first clause leaves marks on the table."
          },
          "example": {
            "title": "Make the example do work",
            "body": "When they ask for an example, keep it accurate to that question. A strong example is contrastive (this, not that), short, and easy to follow."
          },
          "whenClear": {
            "title": "When it's clear, go on",
            "body": "Once the parts and the example are in, stop. Don't pad. The examiner will take you forward."
          },
          "sayTheShape": {
            "title": "Say the shape first",
            "body": "Open with how you'll answer — the parts, then the example — so the examiner can follow you."
          },
          "useTheirWords": {
            "title": "Use the question's words",
            "body": "Echo the terms they used. It shows you heard the ask and keeps the answer on that question."
          },
          "nameTheApproach": {
            "title": "If stuck, name the approach",
            "body": "Say the method or first step out loud. A visible approach scores more than a silent pause."
          }
        },
        "orientationSkip": "Skip orientation",
        "muteBed": "Mute waiting music",
        "unmuteBed": "Unmute waiting music",
        "groupBriefingStarting": "Group briefing is starting."
      }
    },
    "practice": {
      "banner": "This is a dry run — not graded",
      "startCta": "Start dry run",
      "starting": "Starting…",
      "startFailed": "Could not start the dry run. Try again.",
      "agentUnavailable": {
        "title": "Examiner problem",
        "body": "The examiner had a problem. Start the dry-run again."
      },
      "asideTitle": "Try a dry run",
      "asideBody": "Check your camera, microphone and ID photos, then answer two questions from this exam on your own. Spoken slots are placeholders like [some case], not the fillers you will get in the live exam. Nothing is graded, no record is kept.",
      "unavailable": "Sorry, the dry run is currently not available.",
      "examinerChecking": "Checking that the AI examiner is available…",
      "joiningRoom": "Joining the exam room…",
      "waiting": {
        "title": "You're ready to start",
        "body": "You're all set. Start when you are — the AI examiner joins with you."
      },
      "wrapUp": {
        "body": "Thank you. This was a dry run — nothing was graded and no record was kept."
      },
      "lastQuestionWrap": {
        "title": "You're finished",
        "body": "Your answers are in. This dry run is wrapping up — nothing was graded."
      }
    },
    "consent": {
      "title": "Before we begin — your consent",
      "purpose": {
        "recorded": "Camera, microphone and screen are recorded",
        "proctorGrade": "To proctor the exam and grade your answers",
        "appealRecord": "Kept as a record in case of a complaint or appeal"
      },
      "retention": "Recordings are retained according to policy version {{policyVersion}}.",
      "accept": "I have read and accept"
    },
    "conduct": {
      "title": "Exam code of conduct",
      "lead": "Please confirm each point. You can only continue when all are checked.",
      "items": {
        "surroundings": {
          "title": "Surroundings",
          "body": "I am alone. No one else can see my screen or hear this exam, and I will not communicate with anyone during it."
        },
        "materials": {
          "title": "Materials",
          "body": "I have no notes, books, phones, second screens, or other aids within reach, except what this exam explicitly allows."
        },
        "technicalMeans": {
          "title": "Technical means",
          "body": "I will not use AI tools, search, messaging apps, hidden devices, or any other technical means to get help during the exam."
        },
        "consequences": {
          "title": "Consequences",
          "body": "I understand that breaking any of these rules means I fail this exam immediately."
        }
      },
      "confirm": "I confirm — continue"
    },
    "idCapture": {
      "title": "Verify your identity",
      "body": "Hold your ID next to your face and capture a clear photo.",
      "capture": "Capture photo",
      "retake": "Retake",
      "retryCamera": "Retry camera",
      "alignmentHint": "Align your face in the oval and your ID in the frame. Use good lighting.",
      "previewPlaceholder": "Camera preview will appear here.",
      "awaitingTitle": "ID submitted",
      "awaitingBody": "Your photo was submitted and is awaiting supervisor approval. Please stay in the room.",
      "progress": {
        "document": "ID document",
        "face": "Your face"
      },
      "document": {
        "eyebrow": "Photo 1 of 2",
        "title": "Hold your ID document up to the camera",
        "body": "Any official document with your photo and your name, for example:",
        "accepted": {
          "passport": "Passport",
          "drivingLicence": "Driving licence",
          "studentId": "Student ID card"
        },
        "acceptedMore": "or similar",
        "frameLabel": "Side with your photo",
        "hint": "Hold it close so your name is easy to read. Avoid glare.",
        "capture": "Take photo of ID document",
        "alignmentHint": "Fill the frame with your ID document. Avoid glare and keep the text in focus.",
        "awaitingTitle": "ID document captured",
        "awaitingBody": "Next, capture a photo of your face."
      },
      "selfie": {
        "eyebrow": "Photo 2 of 2",
        "title": "Now a photo of your face",
        "body": "Put your ID document away and look straight into the camera.",
        "doLabel": "You, live on camera",
        "dontLabel": "Not the photo on your ID",
        "frameLabel": "Your face",
        "hint": "Face the light so your face is clearly visible.",
        "capture": "Take photo of my face",
        "alignmentHint": "Center your face in the oval. Use good, even lighting.",
        "awaitingTitle": "Identity submitted",
        "awaitingBody": "Your photos were submitted and are awaiting supervisor approval. Please stay in the room."
      },
      "review": {
        "title": "Check your photos before sending",
        "body": "Your supervisor compares these two photos. The left one must be you, live on camera, not the photo from your ID.",
        "send": "Send to supervisor",
        "retakeFace": "Retake face photo",
        "retakeDocument": "Retake ID photo",
        "sendFailed": "We couldn't send your photos. Check your connection and try again.",
        "alreadySent": "Your photos have already been sent.",
        "faceLabel": "Your face",
        "documentLabel": "Your ID document"
      }
    },
    "idReject": {
      "blurry": "Photo is blurry",
      "name_not_legible": "Name is not legible",
      "face_not_visible": "Face is not visible",
      "wrong_document": "Wrong document type",
      "other": "ID photo was rejected",
      "fallback": "Your ID photo was rejected",
      "retakePrompt": "Please retake your ID photo.",
      "retakeButton": "Retake photo"
    },
    "pause": {
      "lecturerPause": {
        "title": "Paused by your supervisor",
        "body": "The clock is stopped. Please hold on."
      },
      "helpRequested": {
        "title": "Help requested — clock paused",
        "body": "Your supervisor has been notified and will join you."
      },
      "mediaDisabled": {
        "title": "Exam paused — restore your devices",
        "body": "We've paused to protect your exam. Restore the devices below to resume.",
        "confirmingTitle": "Confirming restore…",
        "confirmingBody": "Your devices look good locally. We are confirming with the server so the exam clock can resume.",
        "blockedCamera": "Your browser is still blocking the camera. Allow it for {{host}}, then tap Turn camera on again.",
        "blockedMicrophone": "Your browser is still blocking the microphone. Allow it for {{host}}, then tap Unmute microphone again.",
        "blockedScreen": "Screen sharing didn't start. Pick your entire screen in the browser prompt, then tap Re-share screen.",
        "howToAllowCamera": "How to allow the camera in your browser",
        "howToAllowMicrophone": "How to allow the microphone in your browser"
      },
      "selfHeal": {
        "enableCamera": "Turn camera on",
        "unmuteMic": "Unmute microphone",
        "reshareScreen": "Re-share screen"
      },
      "technical": {
        "title": "Exam paused",
        "body": "The clock is paused on the server while we resolve a connection issue.",
        "remainingSeconds": "{{count}} seconds remaining before this session is invalidated under exam regulations",
        "reconnectedTitle": "You're back",
        "reconnectedBody": "Your connection is back. Resuming your exam…",
        "stillConfirming": "Still confirming — {{count}} seconds left"
      },
      "recordingRestart": {
        "title": "Exam paused",
        "body": "Restarting the recording — your clock is paused."
      }
    },
    "reconnect": {
      "title": "Reconnecting…",
      "body": "Your place is saved. The clock is paused on the server.",
      "hint": "Trying to restore your connection…"
    },
    "wrapUp": {
      "completed": {
        "title": "You're all done",
        "body": "Thank you. Your answers and recording have been submitted. Your supervisor will grade them and you'll be notified when results are available.",
        "bodyNoRecording": "Thank you. Your answers have been submitted. Your supervisor will grade them and you'll be notified when results are available.",
        "bulletRecording": "Recording stops automatically."
      },
      "aborted": {
        "title": "This session was ended",
        "body": "Your supervisor will follow up with next steps."
      },
      "notStarted": {
        "title": "This exam didn't start",
        "body": "You left before the exam began. You can book another slot for this exam from the module."
      },
      "closed": {
        "title": "The exam session has ended.",
        "body": "Thank you for joining. Your supervisor will follow up if anything else is needed."
      },
      "cohort": {
        "titleComplete": "Exam complete",
        "titleEmpty": "Exam ended",
        "emptyBody": "No students were in this exam.",
        "countLine": "{{clean}} of {{total}} sent to grading automatically",
        "voidedCountLine": "{{voided}} voided — not graded",
        "needsDecision": "{{count}} outcome(s) need your decision below",
        "sentToGrading": "Sent to grading",
        "cancelledRebook": "Cancelled — student can rebook",
        "recordingMissing": "Submitted · recording missing",
        "noShow": "No show — never joined",
        "notCompleted": "Not completed (ended early)",
        "voidedNotGraded": "Voided — not graded",
        "sendToGrading": "Send to grading",
        "cancelAndRebookShort": "Cancel & rebook",
        "confirmOutcomes": "Confirm outcomes",
        "submitForEvaluation": "Submit for evaluation",
        "cancelAndRebook": "Cancel & allow re-booking",
        "rowError": "Couldn't save — try again.",
        "reconciliationNote": "You can leave anytime. Unresolved outcomes follow the defaults above — sat students go to grading, no-shows are cancelled for re-booking. Use Confirm outcomes to apply your selections.",
        "batchCancelDialogTitle": "Cancel & allow re-booking",
        "batchCancelDialogBody": "Some outcomes will be cancelled so students can re-book. They will be notified. Continue?",
        "backToSchedule": "Back to schedule",
        "goToEvaluationDesk": "Go to Evaluations",
        "cancelDialogTitle": "Cancel & allow re-booking",
        "cancelDialogBody": "This cancels {{name}}'s exam and lets them re-book. They'll be notified. Continue?",
        "cancelDialogConfirm": "Continue"
      }
    },
    "groupBriefing": {
      "phaseLabel": "Group briefing",
      "title": "Group briefing",
      "body": "Listen for final instructions. Your personal exam starts automatically after this briefing.",
      "waitingForVideo": "Waiting for the supervisor's video",
      "waitingHint": "Stay here. The briefing will begin shortly.",
      "brieferConnectionDroppedSuffix": "'s connection dropped",
      "brieferFallbackName": "The supervisor",
      "liveBriefing": "Live briefing",
      "prepListen": "Listen for final instructions",
      "prepMediaReady": "Keep camera, microphone, and screen ready",
      "prepAutoStart": "Your personal exam starts automatically",
      "raiseHand": "Raise hand",
      "lowerHand": "Lower hand",
      "handRaised": "Hand raised",
      "raiseHandFailed": "Couldn't raise your hand. Tap again.",
      "lowerHandFailed": "Couldn't lower your hand. Tap again.",
      "examStartingTitle": "Your exam is starting",
      "movingToExamRoom": "Moving you to your exam room.",
      "steps": {
        "device": "Camera & mic",
        "consent": "Consent",
        "screenShare": "Share your screen",
        "identity": "Identity check",
        "groupBriefing": "Group briefing",
        "groupBriefingSubtitle": "listen now",
        "exam": "Your exam",
        "examSubtitle": "starts automatically"
      }
    },
    "lecturer": {
      "engagedPauseBanner": "Exam paused for this student. Nothing said now is part of the exam.",
      "conferenceReady": "You are connected. Start the exam when you are ready.",
      "presenceSetup": {
        "title": "Set up group briefing",
        "body": "Capture the round supervisor avatar students will see during the exam, then enter the briefing room.",
        "checkingSaved": "Checking for a saved photo…",
        "previewPlaceholder": "Camera preview will appear here",
        "preparingCamera": "Preparing camera…",
        "retake": "Retake avatar photo",
        "update": "Update avatar photo",
        "takePhoto": "Take avatar photo",
        "confirm": "Use photo and go to exam pre-flight check",
        "checklistAvatarReady": "Avatar ready",
        "checklistBriefingLive": "Briefing is live before recording",
        "checklistExamNext": "Exam starts next",
        "avatarLoadFailed": "Could not load your saved avatar. Check your connection and try again.",
        "avatarLoadRetry": "Try again"
      },
      "preflightReview": {
        "title": "Pre-flight review",
        "subtitle": "— accept each student's identity & consent, then start the exam",
        "capacitySingle": "1:1 · capacity 1",
        "capacityCohort": "1:N · capacity {{count}}",
        "noStudents": "No students have booked this slot yet",
        "studentsColumn": "STUDENTS",
        "supervisors": {
          "title": "SUPERVISORS",
          "empty": "No supervisors connected yet",
          "hereCount": "{{count}} here",
          "microphone": "Microphone",
          "copyLink": "Copy supervisor link",
          "linkCopied": "Link copied",
          "micFailed": "Your microphone did not turn on. Check browser permission and try again.",
          "connecting": "Connecting supervisors…"
        }
      },
      "idReview": {
        "title": "Identity review",
        "consentRecorded": "Consent: recorded {{time}}",
        "consentAccepted": "Consent accepted {{time}}",
        "consentPending": "Consent not yet recorded",
        "idPhotoStatus": "ID photo: {{status}}",
        "photoSubmitted": "ID photos submitted",
        "awaitingPhoto": "Awaiting photo",
        "notJoinedYet": "Not joined yet",
        "registeredNotJoined": "Registered — not joined yet",
        "registeredHeader": "Registered — waiting to join",
        "joinGraceOpen": "Can join until {{closeTime}} · {{remaining}} min left",
        "joinClosed": "Join closed — cannot enter.",
        "inLobbySettingUp": "In lobby — setting up",
        "approve": "Confirm identity",
        "approved": "Approved",
        "reject": "Request retake",
        "captionPhoto": "Student photo",
        "captionIdDocument": "ID document",
        "noIdPhoto": "No ID photo",
        "viewPhotos": "View photos",
        "rejectReasonPlaceholder": "Reason for retake (required)",
        "rejectReasonPrompt": "Reason for rejection",
        "rejectNotePlaceholder": "Additional note (optional)",
        "rejectCancel": "Cancel",
        "rejectSubmit": "Request retake",
        "retakeDialogTitle": "Request a new photo from {{name}}",
        "continue": "Continue to start gate"
      },
      "startGate": {
        "title": "Ready to begin?",
        "clearedCount": "{{ready}} of {{total}} ready to start",
        "readyCountSuffix": "students fully cleared",
        "blocker": "{{name}} not ready",
        "recordingNote": "Starting moves everyone into the exam and begins recording.",
        "optionPartial": "Start for cleared ({{count}})",
        "optionAll": "Wait for everyone",
        "submit": "Start the exam",
        "submitSingle": "Start exam",
        "reviewFirst": "Approve ID first",
        "startFailed": "Could not start the exam. Try again.",
        "briefingFailed": "Could not open group briefing. Try again.",
        "orientationWarning": "Waiting for {{studentNames}} to finish the orientation.",
        "joinClosed": "Join closed",
        "scheduledStart": "Exam starts {{time}}",
        "scheduledStartWithGrace": "Exam start {{time}} (+{{minutes}} min late join grace time)",
        "waitingToJoin": "Waiting for {{studentNames}} to join.",
        "graceWaitingUntil": "Waiting until {{time}} for remaining students to join.",
        "waitingCheckIn": "Waiting for {{studentNames}} to finish check-in.",
        "joinClosedNobody": "No student is ready to start.",
        "idReviewBlockHint": "Review {{studentName}}'s ID to start.",
        "idReviewBlockHintMany": "Confirm student IDs to start.",
        "partialConfirmTitle": "Start with {{ready}} of {{total}} students?",
        "partialConfirmMessage": "{{name}} isn't ready and can't take part. This counts as an attempt for {{name}}.",
        "partialConfirmAccept": "Start anyway",
        "continueToBriefing": "Continue to briefing",
        "examinerUnavailable": "AI Examiner is not available. You cannot proceed with this exam. Please contact support.",
        "examinerUnavailableWithEmail": "AI Examiner is not available. You cannot proceed with this exam. Please contact support at {{email}}.",
        "examinerChecking": "Checking AI Examiner availability…",
        "cancelTechnicalProblem": "Cancel session (technical problem)",
        "cancelTechnicalConfirmTitle": "Cancel this session?",
        "cancelTechnicalConfirmMessage": "The AI examiner is unavailable. Students will be asked to reschedule. This does not count as an attempt.",
        "cancelTechnicalConfirmAccept": "Cancel session",
        "cancelTechnicalFailed": "Could not cancel the session. Try again.",
        "supervisorNoShowCancelled": "This session was cancelled at {{cancelTime}} because no supervisor had joined. Students were told it does not count as an attempt.",
        "technicalCancelled": "This session was cancelled at {{cancelTime}} because the AI examiner was unavailable. Students were told it does not count as an attempt."
      },
      "transitionProgress": {
        "openBriefing": {
          "title": "Opening group briefing",
          "line1": "Opening the shared room…",
          "line2": "Notifying students…",
          "line3": "Preparing exam rooms in the background. This can take several seconds."
        },
        "startExam": {
          "title": "Starting the exam",
          "line1": "Preparing to start…",
          "line2": "Students stay in the briefing until the rooms are ready.",
          "line3": "This usually takes a few seconds."
        }
      },
      "readiness": {
        "notJoined": "Registered — not joined yet",
        "inLobby": "In lobby — setting up",
        "awaitingIdReview": "Awaiting ID review",
        "idRejected": "ID rejected — needs resubmit",
        "watchingOrientation": "Watching orientation",
        "readyToStart": "Ready to start",
        "movingToExamRoom": "Moving to exam room",
        "waitingForExaminer": "Waiting for AI examiner",
        "inExam": "In exam",
        "inExamWithProgress": "In exam · Q{{current}}/{{total}}",
        "notConnected": "Disconnected — not connected",
        "presenceUnknown": "Registered — not joined yet",
        "connectingMedia": "Connecting media",
        "completed": "Submitted",
        "aborted": "Exam ended before submission"
      },
      "cohort": {
        "supervising": "supervising {{count}} · {{phase}}",
        "liveBar": "You're live · supervising {{count}} · recording",
        "liveBarBase": "You're live · supervising {{count}}",
        "liveBarRecordingSuffix": " · recording",
        "screenOff": "screen off",
        "feedUnavailable": "no feed",
        "feedPaused": "Feed paused",
        "reconnectFeed": "Reconnect feed",
        "needsYou": "Needs you",
        "onTrack": "Students in exam",
        "waitingExaminerHeader": "In exam room",
        "movingRoomHeader": "Moving to exam room",
        "preflightActiveHeader": "Pre-flight / ID review",
        "registeredHeader": "Registered — waiting to join",
        "registeredNotJoined": "Registered — not joined",
        "submitted": "Submitted",
        "submittedBadge": "Submitted",
        "handLabel": "Hand",
        "examinerNotResponding": "AI examiner not responding",
        "observeStudent": "Observe {{name}}",
        "notCompleted": "Not completed",
        "voidHeader": "Session void — rebook required",
        "notCompletedHint": "Exam ended before submission",
        "submittedHint": "Exam submitted — awaiting cohort wrap-up",
        "pauseAll": "Pause all",
        "messageAll": "Message all",
        "messageDialogTitle": "Message the whole cohort",
        "messagePlaceholder": "Let students know what's happening (they can dismiss it).",
        "messageSend": "Send to all",
        "endCohort": "End exam",
        "endDialogTitle": "End exam",
        "endDialogBody": "End the exam for the whole cohort? Students still in progress will be stopped.",
        "endDialogBodyInProgress": "{{count}} student(s) are still mid-exam. What should happen to their attempt?",
        "endDialogGradeAnswers": "Grade answers so far",
        "endDialogVoidAttempt": "Void attempt",
        "endDialogConfirm": "End exam",
        "endSuccess": "Exam ended for the cohort.",
        "closeNotReady": "The cohort is not ready to end yet.",
        "reset": "Reset exam",
        "resetDialogTitle": "Reset exam?",
        "resetDialogBody": "Reset {{name}}'s exam? This clears their current progress and draws fresh questions. They stay in the room.",
        "resetDialogConfirm": "Reset exam",
        "resetSuccess": "Exam reset for the student.",
        "cancelAndRebook": "Cancel & allow re-booking",
        "cancelDialogTitle": "Cancel booking?",
        "cancelDialogBody": "Cancel {{name}}'s booking? They leave this exam and can book again. Other students are not affected.",
        "cancelDialogConfirm": "Cancel & allow re-booking",
        "cancelSuccess": "Booking cancelled — student can rebook.",
        "tileOverflowLabel": "Student actions",
        "remove": "Remove from exam",
        "removeDialogTitle": "Remove from exam",
        "removeDialogBody": "Remove {{name}} from this exam? Their run is ended and they leave the room. This cannot be undone.",
        "removeDialogConfirm": "Remove",
        "removeSuccess": "Student removed from the exam.",
        "rosterChanged": "The roster changed — refreshed. Try again if needed.",
        "listen": "Listen",
        "listening": "Listening",
        "observe": "Observe",
        "observing": "Observing",
        "observePresenceChip": "{{name}} can see you · you hear them",
        "observeHopLeft": "You left {{name}} — they can no longer see you.",
        "youAreVisible": "You are visible",
        "youAreSpeaking": "You are speaking",
        "examPaused": "Exam paused",
        "selfPreviewLabel": "You — what the student sees",
        "stopObserve": "Return to overview",
        "appear": "Appear",
        "hide": "Return to overview",
        "backToOverview": "Return to overview",
        "leave": "Leave",
        "engage": "Engage",
        "engageNamed": "Engage {{name}}",
        "observeNextStudent": "Observe next student",
        "appearConsequence": "They will see your face. The AI keeps asking.",
        "engageConsequence": "You talk. The AI pauses.",
        "closeObserve": "Close observe",
        "engagePauseConfirmTitle": "Engage?",
        "engagePauseConfirmMessage": "This will pause the clock in the student's exam. Nothing said during this engagement is part of the exam.",
        "liveBarWithColleagues": " · with {{names}}",
        "colleagueObserving": "{{name}} · Observing",
        "colleagueHereWithYou": "{{name}} · Here with you",
        "colleagueEngaged": "{{name}} · Engaged",
        "engageBlockedByHolder": "{{name}} is engaged with this student",
        "appearBlockedByHolder": "{{name}} is here with this student",
        "supervisionCameraBlocked": "Camera blocked — students still see your photo until you enable the camera.",
        "noAudio": "No audio",
        "dropIn": "Drop in",
        "next": "Next",
        "takeOver": "Take over",
        "timeRemaining": "{{time}} left",
        "noQuestions": "No questions",
        "liveBadge": "LIVE",
        "connecting": "Connecting…",
        "notJoined": "Not joined yet",
        "cameraOff": "Camera off",
        "noScreenShared": "No screen shared",
        "zoomScreenShare": "Zoom shared screen",
        "stateRaisedHand": "Raised hand — HELP",
        "stateDone": "Done — awaiting next",
        "statePaused": "Paused",
        "stateAgentDown": "AI examiner down — take over",
        "stateAgentReconnecting": "Reconnecting — timer paused",
        "voidSupervisionAbsence": "Ended — no supervisor was present. Student must rebook.",
        "voidIntegrityBudgetExceeded": "Ended — the student was offline too long. Student must rebook.",
        "voidExaminerUnavailable": "Ended — the examiner could not continue. Student must rebook.",
        "voidSessionEndedGeneric": "Session ended — student must rebook.",
        "supervisionAbsenceCountdown": "Not enough supervisors present — students' sessions end in {{time}} unless a supervisor joins.",
        "stateExaminerUnavailable": "AI examiner unavailable — take over",
        "stateStudentDisconnected": "Disconnected — reconnecting",
        "stateRecordingFailed": "Recording interrupted — decide whether to continue, abort, or reschedule",
        "stateSessionExpired": "Session expired",
        "admitted": "admitted",
        "notAdmitted": "not admitted",
        "integrity": {
          "camera": "camera",
          "microphone": "microphone",
          "screen": "screen sharing",
          "connection": "connection",
          "recording": "recording",
          "notIntact": "Integrity not intact — {{sources}} off for {{duration}}",
          "guidance": "Drop in to assist, or remove from exam if it is not restored.",
          "badge": "Integrity · {{duration}}"
        }
      },
      "backToOverview": "Return to overview",
      "backToCohort_one": "Return to overview ({{count}} other)",
      "backToCohort_other": "Return to overview ({{count}} others)",
      "engageActions": "Exam actions",
      "goToNextQuestion": "Go to next question",
      "repeatPreviousQuestion": "Repeat previous question",
      "resetTimerForQuestion": "Reset timer for current question",
      "abortThisStudentsExam": "Abort this student's exam",
      "groupBriefing": {
        "roomTitle": "Group briefing",
        "roomSubtitle": "Give final instructions, then start the exam.",
        "liveToStudents": "Live to {{count}} students",
        "startExam": "Start the exam",
        "startFailed": "Could not start the exam. Try again.",
        "departureTitle": "Starting the exam",
        "departureStartingCard": "Starting…",
        "departureDevicesOff": "Your camera and microphone are off.",
        "departurePendingSubtitle": "Preparing to start…",
        "mute": "Mute",
        "unmute": "Unmute",
        "muteAllDefault": "Mute all",
        "previewVideoLater": "Preview video (later)",
        "previewVideoHelper": "This space can later host a short video explaining how the exam works.",
        "steps": {
          "idReview": "ID review",
          "idReviewSubtitle": "{{count}} students accepted",
          "avatarPhoto": "Avatar photo",
          "activeStep": "active step",
          "groupBriefing": "Group briefing",
          "liveToStudents": "live to students",
          "exam": "Exam",
          "examSubtitle": "starts after briefing"
        }
      }
    },
    "waitingForStudent": "Waiting for the student to join...",
    "tooEarly": {
      "title": "This meeting room is not open yet",
      "body": "The meeting room is not available yet. Please come back closer to your scheduled time.",
      "bodyWithDuration": "The meeting room opens in {{duration}}. Please come back closer to your scheduled time.",
      "back": "Back to courses",
      "durationDays": "{{days}} day",
      "durationDays_plural": "{{days}} days",
      "durationDaysHours": "{{days}}d {{hours}}h",
      "durationHours": "{{hours}} hour",
      "durationHours_plural": "{{hours}} hours",
      "durationHoursMinutes": "{{hours}}h {{minutes}}min",
      "durationMinutes": "{{minutes}} min",
      "durationSoon": "less than a minute"
    }
  },
  "meeting": {
    "lobbyTitle": "Get ready to join",
    "lobbyIntro": "Check your camera and microphone, then join the meeting.",
    "lobbyPrimingBody": "Your browser will ask for permission — that's your browser's own security check, not us. Choose Allow so students can see and hear you.",
    "enableButton": "Turn on camera & mic",
    "waiting": "Waiting for your browser…",
    "blockedLead": "Your browser is blocking your camera and microphone for this site, and may not ask again.",
    "blockedFix": "Click the padlock to the left of the web address → set Camera and Microphone to Allow → then Try again.",
    "blockedConsequence": "Students cannot see or hear you until this is allowed.",
    "tryAgain": "Try again",
    "moreHelp": "More help",
    "join": "Join meeting",
    "leave": "Leave",
    "leaveConfirmTitle": "Leave the meeting?",
    "leaveConfirmMessage": "You will disconnect from the room. You can rejoin if the session is still open.",
    "you": "You",
    "microphone": "Microphone",
    "camera": "Camera",
    "cameraOffPreview": "Camera is off",
    "reconnecting": "Reconnecting...",
    "connectionLostTitle": "Connection lost",
    "connectionLostBody": "Your connection to the meeting was interrupted. Try joining again.",
    "rejoin": "Rejoin",
    "youAreSharing": "You are sharing your screen",
    "isPresenting": "{{name}} is presenting"
  },
  "slotMeeting": {
    "title": "Live session",
    "loading": "Loading your booking...",
    "noBooking": "No active booking found for this session.",
    "notAvailable": "This session can't be joined in the app.",
    "backToCourses": "Back to courses"
  },
  "generateWithAI": {
    "label": "GENERATE WITH AI",
    "generating": "Generating...",
    "descriptionLabel": "GENERATE DESCRIPTION WITH AI"
  },
  "people": {
    "profile": {
      "title": "Profile",
      "photo": {
        "title": "Photo",
        "help": "Connections see your photo. Skip it and they see your initials.",
        "upload": "Upload a photo",
        "replace": "Replace photo",
        "webcam": "Use webcam",
        "remove": "Remove photo",
        "showToConnections": "Show my photo to connections"
      },
      "contacts": {
        "title": "How people reach you",
        "help": "Only accepted connections see these. Nothing here is public.",
        "share": "Share with connections",
        "email": {
          "label": "Email to share",
          "placeholder": "name@example.com",
          "help": "This is not your login email. Type the address you are happy to share.",
          "invalid": "Enter a valid email address."
        },
        "phone": {
          "label": "Phone (optional)",
          "placeholder": "+49 170 1234567"
        },
        "whatsapp": {
          "label": "WhatsApp (optional)",
          "placeholder": "+49 170 1234567"
        }
      },
      "gss": {
        "title": "Group study sessions",
        "toggle": "Open to connect after sessions I register for",
        "helpOn": "Classmates who registered for the same session can see your first name and photo, and send you a request.",
        "helpOff": "You will not appear on other students' session lists. You can still see people who are open and send them a request.",
        "helpLocked": "Add an email or phone number first so classmates can reach you."
      },
      "preview": {
        "title": "What connections see",
        "emptyTitle": "Nothing to share yet",
        "emptyBody": "Add at least one contact so classmates can reach you after a session.",
        "emptySubtitle": "No way to reach you yet"
      },
      "save": {
        "cta": "Save profile",
        "clean": "No unsaved changes",
        "dirty": "Unsaved changes",
        "success": "Profile saved.",
        "error": "Could not save your profile. Check your connection and try again."
      },
      "loadErrorTitle": "Could not load your profile.",
      "loadErrorBody": "Check your connection and try again.",
      "tryAgain": "Try again"
    },
    "photo": {
      "capture": {
        "title": "Take a profile photo",
        "body": "Only you decide when the picture is taken. Nothing is uploaded until you confirm.",
        "take": "Take photo",
        "retake": "Retake",
        "use": "Use this photo",
        "upload": "Upload a photo instead",
        "preparing": "Preparing camera…",
        "placeholder": "Camera preview will appear here",
        "deniedTitle": "Camera blocked",
        "deniedBody": "Your browser blocked camera access for Flare. Allow it in the address bar and try again, or upload a photo instead.",
        "retry": "Try again",
        "uploadError": "Could not upload the photo. Try again."
      }
    },
    "reach": {
      "email": "Email",
      "call": "Call",
      "whatsapp": "WhatsApp"
    },
    "row": {
      "connect": "Connect",
      "sending": "Sending…",
      "pendingOut": "Request sent",
      "withdraw": "Cancel request",
      "pendingIn": "Wants to connect",
      "accept": "Accept",
      "decline": "Decline",
      "unavailable": "Not available right now",
      "retry": "Try again",
      "errorSend": "Could not send your request. Try again.",
      "errorAction": "Something went wrong. Try again.",
      "menuRemove": "Remove connection",
      "connected": "Connected",
      "viewContact": "View contact"
    },
    "toast": {
      "accepted": "{{name}} is in My connections"
    },
    "connections": {
      "title": "My connections",
      "pendingIn": "Waiting for you",
      "pendingOut": "You asked",
      "accepted": "Connections",
      "emptyTitle": "No connections yet",
      "emptyBody": "After a group study session, you can connect with classmates who registered.",
      "loadErrorTitle": "Could not load your connections.",
      "loadErrorBody": "Check your connection and try again.",
      "tryAgain": "Try again",
      "remove": {
        "title": "Remove {{name}}?",
        "message": "{{name}} will no longer see your contact details, and you will no longer see theirs.\n\nAnything you already shared stays with them — removing a connection stops future access, it cannot take back an address they already have.",
        "confirm": "Remove connection",
        "error": "Could not remove this connection. Try again."
      }
    },
    "gss": {
      "title": "People who registered",
      "subtitle": "Only classmates who registered for this session and are open to connect. Send a request and they can accept.",
      "waitingTitle": "Still loading the people from this session.",
      "waitingBody": "Check again in a moment.",
      "checkAgain": "Check again",
      "emptyIn": "Nobody else from this session is open to connect right now.",
      "emptyInBody": "You are listed, so if someone opens up later they will appear here.",
      "emptyOut": "Nobody else from this session is open to connect right now.",
      "emptyOutBody": "You are not listed either, so classmates from this session cannot find you here.",
      "openProfile": "Open profile",
      "errorTitle": "Could not load the people from this session.",
      "errorBody": "Check your connection and try again.",
      "tryAgain": "Try again",
      "gate": {
        "title": "Meet the people who registered",
        "body": "{{count}} other students registered and are open to connect. Add a way for them to reach you, then you can send a request.",
        "needContact": "At least one contact — email, phone or WhatsApp",
        "required": "REQUIRED",
        "needPhoto": "A photo",
        "optional": "OPTIONAL — classmates see your initials",
        "openProfile": "Open profile",
        "notNow": "Not now",
        "photoNote": "You have no photo, so classmates see your initials. Add one if you would rather be recognised."
      }
    }
  }
}
